import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "types/store";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import circleCheckGreen from "images/Circle Check Light 2.svg";
import ShareChatApp from "components/ChatApp/ShareChatApp";
import { Button, ButtonGroup, Accordion, TileItem, Icon } from "aible";
import { Alert } from "react-bootstrap";
import { LineInput } from "components/Inputs/LineInput";
import LabeledToggle from "components/Inputs/Toggle/Toggle";
import { HexColorPicker } from "react-colorful";
import ChatGPT, { WhatsChangedInput } from "components/ChatGPT/ChatGPT";
import IconPoweredAible from "images/Aible_Logo/aible-powered-light.svg";
import IconPoweredAibleDark from "images/Aible_Logo/aible-powered-dark.svg";
import IconHPE from "images/HPE/hpe.svg";
import IconVideoChip from "images/video_chip.svg";
import IconVideoChipGray from "images/video_chip_gray.svg";
import AWSIconSmall from "images/aws-brands-1.svg";
import AzureIconSmall from "images/microsoft-azureicon-seeklogo-1.svg";
import GCPIcon from "images/gcp.svg";
import IconPerformance from "images/video_performance.svg";
import IconAccuracy from "images/video_accuracy.svg";
import IconVideoOptionsPurple from "images/video_options_purple.svg";
import IconVideoChatOptionsGray from "images/video_chat_options_gray.svg";
import CloudIcon from "images/Cloud Light Icon 1.svg";
import MicrochipIcon from "images/Microchip AI Light.svg";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as viewReducer from "containers/View/reducer";
import * as tagsReducer from "containers/Tags/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as globalReducer from "containers/App/reducer";
import * as chatAppReducer from "containers/ChatApp/reducer";
import * as projectReducer from "containers/Project/reducer";
import CSVIconGray from "images/csv_light_grey.svg";
import documentSetIconGray from "images/files-gray.svg";
import UndoArrowIcon from "images/arrow-rotate-left-sharp-gray.svg";
import EditIcon from "images/edit-light.svg";
import ChatGPTSettings from "components/ChatGPT/ChatGPTSettings";
import { CHATAPP_IMAGE_SIZE } from "containers/ChatApp/reducer";
import { formatBytes } from "containers/Upload/reducer";
import { toast } from "react-toastify";
import { isEnabled } from "utils/featureFlags";
import styles from "./style.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import Select from "react-select";
import { Dropdown, MenuItem } from "react-bootstrap";
import ChevronDownIcon from "images/Chevron Down Light.svg";
import ContextSelectionPanel from "components/NewChat/ContextSelectionPanel";
import ModelSelector from "components/ChatGPT/ModelSelector";
import DocumentSelector from "components/LanguageModelArtifact/DocumentSelector";
import DatasetSelector from "components/Dataset/DatasetSelector";
import { selectOnChangeWrapper } from "utils/select";
import { isArrEqual } from "utils/collect";
import ChatCapabilityList from "components/ChatGPT/ChatCapabilityList";
import DynamicWidthSelector from "components/ChatGPT/DynamicWidthSelector";
import ToneSelector from "components/ChatGPT/ToneSettings/ToneSelector";
import { TEMPLATES_SAMPLE_DATA } from "containers/ChatGPT/ChatTemplateSampleData";
import FineTuningButton from "components/LanguageModelArtifact/FineTuningButton/FineTuningButton";
import TemplateItemTag from "components/Templates/TemplateItemTag";
import ChatAppLineage from "components/Lineage/ChatAppLineage";
import AgentCModal from "components/Templates/AgentC";
import numeral from "numeral";
import KPIAnalysisSetup from "components/Templates/KPIAnalysisSetup";
import * as homeReducer from "containers/Home/reducer";
import * as reportReducer from "containers/Report/ReportReducer";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
import { SPARK_TEMPLATES } from "@/components/View/Spark/SparkTemplateView";
import KPIMetricsLabels from "components/Next/Dashboard/KPIMetricsLabels";
import { TemplateOptimize } from "components/Templates/VideoTemplate";
import { SettingsKPISelection } from "components/KPIAnalysis/KPIAdvancedSettings";
import { MultiSessionMemoryCreationToggle, MultiSessionMemoryToggle } from "components/ChatGPT/ChatGPTSettings/ConversationMemorySettings";
import { getMultiSessionMemoryCreationEnabled, getMultiSessionMemoryEnabled, getMultiSessionMemoryCount, getMemoryAugmentationPromptTemplate, getMemoryCreationPromptTemplate } from "@/containers/ChatGPT/features/ConversationMemory/selectors";
import * as languageModelArtifactReducer from "@/containers/LanguageModelArtifact/reducer";
import { DEFAULT_DESCRIPTION_SUGGESTION_PROMPT } from "@/containers/ChatGPT/reducer";
import ProjectSelector from "../NewChat/ProjectSelector";
const ChatTemplate = ({ match, history }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const state = location?.state || undefined;
    let defaultDatasetId = undefined;
    let defaultArtifactId = undefined;
    if (state) {
        defaultDatasetId = state?.datasetId;
        defaultArtifactId = state?.artifactId;
    }
    const blueprintId = match?.params?.blueprintId;
    const blueprint = useSelector((state) => blueprintReducer.getBlueprint(state, blueprintId));
    const [createdChatAgentId, setCreatedChatAgentId] = useState(undefined);
    const [showShareModal, setShowShareModal] = useState(false);
    const [isChatOptions, setIsChatOptions] = useState(false);
    const setupTab = useSelector((state) => viewReducer.getTemplateSetupTab(state));
    const updateSetupTab = (val) => dispatch(viewReducer.updateTemplateSetupTab(val));
    const activeCapability = useSelector((state) => tagsReducer.getActiveCapability(state));
    const capabilityTimerId = useSelector((state) => tagsReducer.getCapabilityTimerId(state));
    const isDefaultBlueprint = isNaN(Number(blueprintId));
    const contextSelectionPanelTab = useSelector((state) => chatGPTReducer.getContextSelectionPanelTab(state));
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const isSavedTemplate = blueprint?.wizard?.isSavedWork;
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const isCreatingApp = useSelector((state) => chatAppReducer.getIsCreatingApp(state));
    const isBlueprintsLoading = useSelector((state) => globalReducer.getIsBlueprintsLoading(state));
    const [tryTemplate, updateTryTemplate] = useState(blueprint);
    const [showChatTemplateModal, setShowChatTemplateModal] = useState(false);
    const [showBackWarningModal, setShowBackWarningModal] = useState(false);
    const updateDatasetId = (val) => dispatch(nextReducer.updateDatasetId("new", val));
    const updateArtifactId = (val) => dispatch(chatGPTReducer.updateArtifactId(val));
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const chatAppWizard = chatApp?.wizard;
    const appDescription = useSelector((state) => chatAppReducer.getAppDescription(state));
    const multiSessionMemoryEnabled = useSelector(getMultiSessionMemoryEnabled);
    const multiSessionMemoryCreationEnabled = useSelector(getMultiSessionMemoryCreationEnabled);
    const memoryCreationPromptTemplate = useSelector(getMemoryCreationPromptTemplate);
    const memoryAugmentationPromptTemplate = useSelector(getMemoryAugmentationPromptTemplate);
    const multiSessionMemoryCount = useSelector(getMultiSessionMemoryCount);
    const handleBackToTemplatesConfirm = () => {
        dispatch(viewReducer.updateType(viewReducer.VIEW_TYPE.AGENT_TEMPLATES));
        history.push("/");
    };
    const updateTemplateSetup = (key, value, updateStepKey) => {
        const retTryTemplate = {
            ...tryTemplate,
            wizard: {
                ...tryTemplate?.wizard,
                [key]: value
            }
        };
        if (updateStepKey && retTryTemplate?.wizard?.steps?.[0]?.[key]) {
            retTryTemplate.wizard.steps[0][key] = value;
        }
        updateTryTemplate(retTryTemplate);
    };
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const chatFlow = useSelector((state) => chatGPTReducer.getChatFlow(state));
    const handleSaveTemplate = async (skipInit, name, isKPIIdentical) => {
        let tags = [];
        const wizardTags = tryTemplate?.wizard?.tags;
        if (wizardTags && Array.isArray(wizardTags) && wizardTags.length > 0) {
            tags = [...wizardTags];
        }
        else {
            if (!tryTemplate?.wizard?.isBenchmark) {
                if (tryTemplate?.wizard?.chatGPT?.chatType === "AIBLE" ||
                    tryTemplate?.wizard?.chatGPT?.chatType === "CHATAIBLE_ANALYTICS" ||
                    tryTemplate?.wizard?.chatGPT?.chatType === "WHATS_CHANGED" ||
                    tryTemplate?.wizard?.chatGPT?.chatType === "CHATAIBLE_WHATS_CHANGED" ||
                    tryTemplate?.wizard?.chatGPT?.chatType === "PREDICT" ||
                    tryTemplate?.wizard?.chatGPT?.chatType === "OPTIMIZE") {
                    tags.push(17);
                }
                else if (tryTemplate?.wizard?.chatGPT?.chatType === "SQL" ||
                    tryTemplate?.wizard?.chatGPT?.chatType === "CHATAIBLE_SQL") {
                    tags.push(18);
                }
                else if (tryTemplate?.wizard?.chatGPT?.chatType === "DOCUMENT" ||
                    tryTemplate?.wizard?.chatGPT?.chatType === "CHATAIBLE_DOCUMENT_SUMMARIZATION") {
                    tags.push(21);
                }
                else {
                    tags.push(19);
                }
            }
            else {
                tags.push("BENCHMARK");
            }
        }
        const retDescription = tryTemplate?.wizard?.description ? tryTemplate?.wizard?.description : appDescription;
        const retAppState = {
            templateType: tryTemplate?.wizard?.chatGPT?.chatType,
            base64StringLogo: chatAppWizard?.base64StringLogo ?? tryTemplate?.wizard?.base64StringLogo,
            base64StringBot: chatAppWizard?.base64StringBot ?? tryTemplate?.wizard?.base64StringBot,
            chatButtonCompany: chatAppWizard?.chatButtonCompany ?? tryTemplate?.wizard?.chatButtonCompany,
            headerColor: chatAppWizard?.headerColor ?? tryTemplate?.wizard?.headerColor,
            linkColor: chatAppWizard?.linkColor ?? tryTemplate?.wizard?.linkColor,
            chatButtonColor: chatAppWizard?.chatButtonColor ?? tryTemplate?.wizard?.chatButtonColor,
            backgroundColor: chatAppWizard?.backgroundColor ?? tryTemplate?.wizard?.backgroundColor,
            name: name || tryTemplate?.name,
            description: retDescription,
            nextChat: chatAppWizard?.nextChat ?? tryTemplate?.wizard?.nextChat ?? "",
            headerDarkMode: chatAppWizard?.headerDarkMode ?? tryTemplate?.wizard?.headerDarkMode,
            linkColorDarkMode: chatAppWizard?.linkColorDarkMode ?? tryTemplate?.wizard?.linkColorDarkMode,
            chatButtonDarkMode: chatAppWizard?.chatButtonDarkMode ?? tryTemplate?.wizard?.chatButtonDarkMode,
            backgroundColorDarkMode: chatAppWizard?.backgroundColorDarkMode ?? tryTemplate?.wizard?.backgroundColorDarkMode,
            hideChangeInBehavior: tryTemplate?.wizard?.hideChangeInBehavior,
            hideChangeInPopulation: tryTemplate?.wizard?.hideChangeInPopulation,
            hideChangeInOutcome: tryTemplate?.wizard?.hideChangeInOutcome,
            hideChangeInTotalPopulation: tryTemplate?.wizard?.hideChangeInTotalPopulation,
            renameBehavior: tryTemplate?.wizard?.renameBehavior,
            renameOutcome: tryTemplate?.wizard?.renameOutcome,
            renamePopulation: tryTemplate?.wizard?.renamePopulation,
            renameTotalPopulation: tryTemplate?.wizard?.renameTotalPopulation,
            hideMissingInCharts: tryTemplate?.wizard?.hideMissingInCharts,
            hideOtherInCharts: tryTemplate?.wizard?.hideOtherInCharts,
            tags,
            hideDatesOutsideRange: tryTemplate?.wizard?.hideDatesOutsideRange,
            autoDeepDive: tryTemplate?.wizard?.autoDeepDive,
            autoDeepDiveColumns: tryTemplate?.wizard?.autoDeepDiveColumns,
            autoDeepDiveUseCustomLabels: tryTemplate?.wizard?.autoDeepDiveUseCustomLabels,
            autoDeepDiveCustomLabels: tryTemplate?.wizard?.autoDeepDiveCustomLabels,
            optimizeSetup: tryTemplate?.wizard?.optimizeSetup,
            multiSessionMemoryEnabled: multiSessionMemoryEnabled,
            multiSessionMemoryCreationEnabled: multiSessionMemoryCreationEnabled,
            multiSessionMemoryCount: multiSessionMemoryCount,
            memoryAugmentationPromptTemplate: memoryAugmentationPromptTemplate,
            memoryCreationPromptTemplate: memoryCreationPromptTemplate,
            linkedOptimizeReport: tryTemplate?.wizard?.linkedOptimizeReport,
            isKPIAnalysis: tryTemplate?.wizard?.isKPIAnalysis,
            chatFlow
        };
        const savedApp = await dispatch(chatAppReducer.saveChatApp(retAppState, undefined, undefined, skipInit, true, true, true, true, isKPIIdentical));
        setCreatedChatAgentId(savedApp.id);
        return Promise.resolve(savedApp.id);
    };
    const chatApps = useSelector((state) => viewReducer.getChatApps(state, true));
    const createdChatApp = chatApps.find((app) => app?.id === createdChatAgentId);
    const isDocSum = chatType === "DOCUMENT";
    useEffect(() => {
        dispatch(chatGPTReducer.handleTryChatTemplate(blueprintId));
    }, [blueprintId]);
    useEffect(() => {
        if (!isBlueprintsLoading && blueprint) {
            updateTryTemplate(blueprint);
            if (!showChatTemplateModal) {
                setShowChatTemplateModal(true);
            }
        }
    }, [isBlueprintsLoading]);
    // This is a cleanup function when component unmounts to reset the whole template state back to all the saved agent blueprint states.
    // This is a fix for when reloading a template that had unsaved changes from reflecting the unsaved changes instead of what was saved.
    // Also clears active capability value.
    useEffect(() => {
        // Don't ask my why =(
        setTimeout(() => {
            if (defaultArtifactId) {
                updateArtifactId(defaultArtifactId);
                updateTemplateSetup("artifactId", defaultArtifactId, true);
            }
            if (defaultDatasetId) {
                updateDatasetId(defaultDatasetId);
                updateTemplateSetup("datasetId", defaultDatasetId, true);
            }
        }, 0);
        return () => {
            if (capabilityTimerId) {
                clearTimeout(capabilityTimerId);
                dispatch(tagsReducer.updateCapabilityTimerId(undefined));
            }
            if (activeCapability !== undefined) {
                dispatch(tagsReducer.updateActiveCapability(undefined));
            }
            if (setupTab !== undefined && setupTab !== "Configure") {
                updateSetupTab("Configure");
            }
            dispatch(chatGPTReducer.resetGPT());
        };
    }, []);
    useEffect(() => {
        if (defaultArtifactId) {
            updateArtifactId(defaultArtifactId);
            updateTemplateSetup("artifactId", defaultArtifactId, true);
        }
    }, [defaultArtifactId]);
    useEffect(() => {
        if (defaultDatasetId) {
            updateDatasetId(defaultDatasetId);
            updateTemplateSetup("datasetId", defaultDatasetId, true);
        }
    }, [defaultDatasetId]);
    useEffect(() => {
        if (setupTab !== "Configure") {
            updateSetupTab("Configure");
        }
    }, [blueprintId]);
    useEffect(() => {
        if (isAsking && setupTab !== "Configure") {
            updateSetupTab("Configure");
        }
    }, [isAsking]);
    useEffect(() => {
        return () => {
            setShowChatTemplateModal(false);
        };
    }, []);
    const agentLogo = chatAppWizard?.base64StringLogo ?? tryTemplate?.wizard?.base64StringLogo;
    const agentIcon = chatAppWizard?.base64StringBot ?? tryTemplate?.wizard?.base64StringBot;
    const headerDarkMode = chatAppWizard?.headerDarkMode ?? tryTemplate?.wizard?.headerDarkMode;
    return (React.createElement("div", { className: styles.videoTemplateBase },
        React.createElement("div", { className: styles.paneHolder },
            React.createElement("div", { className: styles.leftPane },
                React.createElement("div", { className: styles.chatTryLeftHeader, style: tryTemplate?.wizard?.headerColor ? { background: tryTemplate?.wizard?.headerColor } : {} },
                    React.createElement("div", { style: { display: "flex" } },
                        agentLogo && (React.createElement("img", { className: styles.chatTryLogoImage, src: agentLogo, style: agentLogo ? { background: "transparent" } : {} })),
                        React.createElement("img", { src: headerDarkMode ? IconPoweredAibleDark : IconPoweredAible }))),
                React.createElement(ChatGPT, { tryChatTemplate: true })),
            React.createElement("div", { className: styles.rightPane }, contextSelectionPanelTab ? (React.createElement(ContextSelectionPanel, { nextId: nextId, isClose: true, forceChatAppInit: true })) : (React.createElement("div", null,
                React.createElement("div", { className: styles.rightPaneHeaderContentWrapper },
                    React.createElement("div", { className: styles.agentHeader },
                        agentIcon && (React.createElement("div", { className: styles.iconPoweredCamPaneIcon, style: { background: "transparent", paddingTop: "8px" } },
                            React.createElement("img", { src: agentIcon }))),
                        React.createElement("div", { className: styles.templateInput },
                            React.createElement(LineInput, { style: { width: "100%", marginRight: "10px", fontSize: "16px" }, value: tryTemplate?.name, onChange: (val) => {
                                    const retTemplate = {
                                        ...tryTemplate,
                                        name: val
                                    };
                                    updateTryTemplate(retTemplate);
                                }, inputClassName: styles.nameInput }),
                            React.createElement("textarea", { className: styles.descriptionMessage, value: tryTemplate?.wizard?.description, onChange: (e) => {
                                    updateTemplateSetup("description", e?.target?.value);
                                } })),
                        React.createElement("div", { className: styles.templateLink },
                            React.createElement("a", { onClick: () => setShowBackWarningModal(true), style: {
                                    borderColor: "transparent",
                                    color: "#697586",
                                    fontSize: "13px"
                                } },
                                React.createElement(FontAwesomeIcon, { icon: faArrowLeft, style: { marginRight: "5px", paddingBottom: "2px" } }),
                                "Back to all templates"))),
                    React.createElement("div", { className: styles.rightButtons },
                        !isEnabled("spark-agents-templates-view") && (React.createElement(ButtonGroup, null,
                            React.createElement(Button, { onClick: () => updateSetupTab("Configure"), active: setupTab === "Configure", className: styles.paneNavigationButton },
                                React.createElement("img", { src: IconVideoOptionsPurple, style: { marginRight: "6px" } }),
                                "Configure"))),
                        React.createElement("div", { style: { display: "flex" } },
                            !isDefaultBlueprint && (React.createElement(Button, { onClick: () => updateSetupTab("Lineage"), active: setupTab === "Lineage", style: {
                                    padding: "10px 12px",
                                    marginRight: "10px"
                                } }, "Lineage")),
                            (!isEnabled("spark-agents-templates-view") ||
                                SPARK_TEMPLATES.map((template) => template.id).includes(blueprintId)) && (React.createElement(Button, { style: { padding: "10px 12px", marginRight: "10px" }, onClick: () => handleSaveTemplate(true), isLoading: isCreatingApp }, "Create Agent")),
                            (!isEnabled("spark-agents-templates-view") ||
                                SPARK_TEMPLATES.map((template) => template.id).includes(blueprintId)) &&
                                isEnabled("show-advanced-agent-settings") && (React.createElement(Dropdown, { id: "settingsDropdown", style: {
                                    display: "flex",
                                    flexWrap: "nowrap",
                                    marginRight: "10px"
                                }, className: styles.settingsDropDown },
                                React.createElement(Dropdown.Toggle, { className: styles.settingsDropDownButton },
                                    React.createElement("img", { src: ChevronDownIcon, style: { width: "20px" } })),
                                React.createElement(Dropdown.Menu, null,
                                    React.createElement(MenuItem, { onClick: () => setIsChatOptions(!isChatOptions), className: styles.settingsDropdownMenuItem },
                                        React.createElement("img", { src: IconVideoChatOptionsGray, style: { width: "18px", marginRight: "6px" } }),
                                        "Advanced Settings"),
                                    !isEnabled("spark-agents-templates-view") && (React.createElement(MenuItem, { className: styles.settingsDropdownMenuItem, onClick: async () => {
                                            const deleteItem = await dispatch(blueprintReducer.handleDelete(blueprint.id));
                                            if (deleteItem) {
                                                dispatch(viewReducer.updateType(viewReducer.VIEW_TYPE.AGENT_TEMPLATES));
                                                history.push("/");
                                            }
                                        }, disabled: isCreatingApp },
                                        React.createElement("div", { style: {
                                                display: "flex",
                                                alignItems: "center"
                                            } },
                                            isCreatingApp ? (React.createElement(LoadingIndicator, { style: {
                                                    width: "20px",
                                                    height: "14px",
                                                    transform: "scale(0.3)",
                                                    margin: "-4px 10px 12px -8px"
                                                } })) : (React.createElement(Icon, { size: 18, style: { marginRight: "6px" }, type: "trashGrey" })),
                                            React.createElement("div", null, "Delete"))))))))),
                    createdChatAgentId && (React.createElement(Alert, { bsStyle: "success" },
                        React.createElement("div", { style: {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            } },
                            React.createElement("div", { style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px"
                                } },
                                React.createElement("img", { src: circleCheckGreen, style: { width: "20px" } }),
                                React.createElement("strong", null, "Your Agent was successfully created!")),
                            React.createElement("div", { style: { display: "flex", gap: "10px" } },
                                React.createElement(Button, { onClick: () => {
                                        if (createdChatApp &&
                                            createdChatApp?.wizard?.isBenchmark &&
                                            createdChatApp?.wizard?.datasetId) {
                                            return dispatch(nextReducer.openBenchmark(createdChatApp?.id));
                                        }
                                        history.push("/next/new/new/" + createdChatAgentId);
                                    } }, "Open"),
                                React.createElement(ShareChatApp, { id: createdChatAgentId, showModal: showShareModal, updateShowModal: () => setShowShareModal(true) }, "Share Public URL")))))),
                isChatOptions ? (React.createElement("div", { className: styles.chatSettings },
                    React.createElement(ChatGPTSettings, { isForceShowSettings: true }))) : (React.createElement("div", { className: styles.setupType }, setupTab === "Overview" ? (React.createElement("div", null,
                    React.createElement(ChatCapabilityList, { defaultShow: true }))) : setupTab === "Try" ? (React.createElement("div", null,
                    React.createElement(TryChatTemplate, { blueprintId: blueprintId, tryTemplate: tryTemplate, updateTemplateWizard: updateTemplateSetup, defaultDatasetId: defaultDatasetId, defaultArtifactId: defaultArtifactId }))) : setupTab === "Deploy" ? (React.createElement("div", null,
                    React.createElement(PerformanceStep, { blueprintId: blueprintId, tryTemplate: tryTemplate, updateTemplateWizard: updateTemplateSetup }))) : setupTab === "Configure" ? (React.createElement("div", null,
                    React.createElement("div", { style: { display: "flex", alignItems: "center" } },
                        React.createElement(Button, { onClick: () => {
                                setShowChatTemplateModal(true);
                            }, type: "primary", style: {
                                marginBottom: "4px",
                                marginRight: "auto"
                            } }, "Use Template Setup"),
                        !isEnabled("spark-agents-templates-view") && isEnabled("model-fine-tuning") && (React.createElement(FineTuningButton, { templateName: tryTemplate?.name }))),
                    chatType === "OPTIMIZE" ? (React.createElement(TemplateOptimize, { style: { width: "100%", height: "unset" } })) : (React.createElement(ChatCapabilityList, { defaultShow: true })),
                    React.createElement("div", { className: styles.brandingAccordionWrapper },
                        React.createElement(Accordion, { defaultShow: false, header: React.createElement("div", { className: styles.brandingAccordionHeader }, "Branding & Tags") },
                            React.createElement("div", { className: styles.brandingContentsContainer },
                                React.createElement(BrandingStep, { blueprintId: blueprintId, tryTemplate: tryTemplate, updateTemplateWizard: updateTemplateSetup }),
                                React.createElement(TaggingOptions, { tryTemplate: tryTemplate, updateTemplateWizard: updateTemplateSetup })))),
                    !isEnabled("spark-agents-templates-view") && !isDocSum && (React.createElement("div", { className: styles.brandingAccordionWrapper },
                        React.createElement(ScheduleAutomaticRefresh, null))))) : setupTab === "Lineage" ? (React.createElement("div", null,
                    React.createElement(ChatAppLineage, { id: blueprintId }))) : (React.createElement("div", null)))))))),
        React.createElement(BackWarningModal, { showModal: showBackWarningModal, updateShowModal: setShowBackWarningModal, onConfirm: handleBackToTemplatesConfirm }),
        React.createElement(ConfigureSetupModal, { tryTemplate: tryTemplate, updateTemplateWizard: updateTemplateSetup, handleSaveTemplate: handleSaveTemplate, blueprintId: createdChatAgentId ?? blueprintId, showTemplateSetup: showChatTemplateModal, setShowTemplateSetup: setShowChatTemplateModal, defaultDatasetId: defaultDatasetId, defaultArtifactId: defaultArtifactId })));
};
const ScheduleAutomaticRefresh = () => {
    const dateOptions = [
        { label: "Day", value: "Day" },
        { label: "Hour", value: "Hour" },
        { label: "Week", value: "Week" },
        { label: "Month", value: "Month" }
    ];
    const timeOptions = [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
        { label: "6", value: "6" },
        { label: "7", value: "7" },
        { label: "8", value: "8" },
        { label: "9", value: "9" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" }
    ];
    const otherTimeOptions = [
        { label: "PM", value: "PM" },
        { label: "AM", value: "AM" }
    ];
    const exceptOptions = [
        { label: "Sunday and Saturday", value: "Sunday and Saturday" },
        { label: "None", value: "None" }
    ];
    const [dateOption, updateDateOption] = useState(dateOptions?.[0]);
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.scheduleFlex },
            React.createElement("input", { type: "checkbox", style: { marginTop: "0px", marginRight: "5px" } }),
            React.createElement("div", { style: { marginRight: "5px" } }, "Run this every"),
            React.createElement("div", { style: { width: "100px", marginRight: "5px" } },
                React.createElement(Select, { options: dateOptions, value: dateOption, onChange: (val) => updateDateOption(val), menuPlacement: "top" })),
            dateOption?.value !== "Hour" && (React.createElement("div", { className: styles.scheduleFlex },
                React.createElement("div", { style: { marginRight: "5px" } }, "at"),
                React.createElement("div", { style: { width: "100px", marginRight: "5px" } },
                    React.createElement(Select, { options: timeOptions, defaultValue: timeOptions?.[0], menuPlacement: "top" })),
                React.createElement("div", { style: { width: "100px" } },
                    React.createElement(Select, { options: otherTimeOptions, defaultValue: otherTimeOptions?.[0], menuPlacement: "top" }))))),
        dateOption?.value === "Day" && (React.createElement("div", { className: styles.scheduleFlex, style: { marginTop: "10px" } },
            React.createElement("div", { style: { marginRight: "5px" } }, "Except"),
            React.createElement("div", { style: { width: "200px" } },
                React.createElement(Select, { options: exceptOptions, defaultValue: exceptOptions?.[0], menuPlacement: "top" })))),
        dateOption?.value === "Hour" && (React.createElement("div", { className: styles.scheduleFlex, style: { marginTop: "10px" } },
            React.createElement("div", { style: { marginRight: "5px" } }, "Except"),
            React.createElement("div", { style: { width: "100px", marginRight: "5px" } },
                React.createElement(Select, { options: timeOptions, defaultValue: timeOptions?.[0], menuPlacement: "top" })),
            React.createElement("div", { style: { width: "100px", marginRight: "5px" } },
                React.createElement(Select, { options: otherTimeOptions, defaultValue: otherTimeOptions?.[0], menuPlacement: "top" })),
            React.createElement("div", { style: { marginRight: "5px" } }, "to"),
            React.createElement("div", { style: { width: "100px", marginRight: "5px" } },
                React.createElement(Select, { options: timeOptions, defaultValue: timeOptions?.[0], menuPlacement: "top" })),
            React.createElement("div", { style: { width: "100px", marginRight: "5px" } },
                React.createElement(Select, { options: otherTimeOptions, defaultValue: otherTimeOptions?.[0], menuPlacement: "top" }))))));
};
const TryChatTemplate = ({ tryTemplate, updateTemplateWizard, defaultDatasetId, defaultArtifactId }) => {
    const dispatch = useDispatch();
    const modelId = useSelector((state) => chatGPTReducer.getModelId(state));
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, "new"));
    const updateDatasetId = (val) => dispatch(nextReducer.updateDatasetId("new", val));
    const artifactId = useSelector((state) => chatGPTReducer.getArtifactId(state));
    const updateArtifactId = (val) => dispatch(chatGPTReducer.updateArtifactId(val));
    const artefactsWithDocumentsFilter = (artifact) => {
        return Boolean(artifact?.metadata?.document_list?.length);
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.chatTrySettingSection },
            React.createElement("div", { className: styles.inputBold }, "What do you want the answers to focus on?"),
            React.createElement("div", null,
                React.createElement("textarea", { style: { height: "100px" }, className: styles.eventFlag, value: tryTemplate?.wizard?.useCaseSettings?.[modelId]?.systemPromptAugment ?? "", onChange: (event) => {
                        const retValue = event.currentTarget.value;
                        const retUseCaseSettings = {
                            ...tryTemplate?.wizard?.useCaseSettings,
                            [modelId]: {
                                ...tryTemplate?.wizard?.useCaseSettings?.[modelId],
                                systemPromptAugment: retValue
                            }
                        };
                        dispatch(chatGPTReducer.updateSystemPromptAugment(retValue));
                        updateTemplateWizard("useCaseSettings", retUseCaseSettings);
                    } }))),
        React.createElement("div", { className: styles.chatTrySettingSection },
            React.createElement("div", { className: styles.inputBold }, "AI Model"),
            React.createElement("div", { className: styles.chatTryDropdownWrapper },
                React.createElement(ModelSelector, { modelId: modelId, updateModelId: (val) => dispatch(chatGPTReducer.updateModelId(val)), hideIcons: true, isDisabled: isAsking, onChange: selectOnChangeWrapper((val) => {
                        dispatch(chatGPTReducer.updateModelId(val));
                        updateTemplateWizard("modelId", val);
                    }), isCreatable: true, selectorStyle: {
                        minWidth: "159px"
                    } }))),
        React.createElement("div", { className: styles.chatTrySettingSection },
            (chatType === "DOCUMENT" || chatType === "AIBLE" || chatType === "SQL" || chatType === "WHATS_CHANGED") && (React.createElement("div", { className: styles.inputBold }, "What data would you like to use?")),
            React.createElement("div", { className: styles.chatTryDropdownWrapper }, chatType === "DOCUMENT" ? (React.createElement(DocumentSelector, { artifactId: defaultArtifactId || artifactId, onChange: (val) => {
                    updateArtifactId(val?.id);
                    updateTemplateWizard("artifactId", val?.id, true);
                }, forceSelection: true, allowUpload: true, menuPlacement: "bottom", filter: artefactsWithDocumentsFilter })) : chatType === "AIBLE" || chatType === "SQL" || chatType === "WHATS_CHANGED" ? (React.createElement(DatasetSelector, { datasetId: defaultDatasetId || datasetId, onChange: (val) => {
                    updateDatasetId(val);
                    updateTemplateWizard("datasetId", val, true);
                }, isStyled: false, isDynamic: false, menuPlacement: "bottom", forceDatasetSelection: true, hideJustChat: true, allowUpload: true, allowAllDatasets: true, filter: chatType === "WHATS_CHANGED" ? "date" : undefined })) : (React.createElement(React.Fragment, null))))));
};
const TaggingOptions = ({ tryTemplate, updateTemplateWizard }) => {
    const templateTags = tryTemplate?.wizard?.tags ?? [];
    const tags = useSelector((state) => tagsReducer.getTags(state));
    const tagOptions = Object.keys(tags).map((tagKey) => {
        return {
            ...tags[tagKey],
            value: tags[tagKey].id
        };
    });
    const industryTagOptions = tagOptions?.filter((option) => option?.type === "INDUSTRY");
    const functionTagOptions = tagOptions?.filter((option) => option?.type === "FUNCTION");
    const typeTagOptions = tagOptions?.filter((option) => option?.type === "TYPE");
    const templateIndustryTags = templateTags?.filter((tagId) => tags[tagId]?.type === "INDUSTRY");
    const templateFunctionTags = templateTags?.filter((tagId) => tags[tagId]?.type === "FUNCTION");
    const templateTypeTags = templateTags?.filter((tagId) => tags[tagId]?.type === "TYPE");
    return (React.createElement("div", { style: { marginTop: "20px", marginBottom: "32px" } },
        React.createElement("div", { className: styles.settingSubtitle, style: { marginBottom: "4px" } }, "Template Tags"),
        React.createElement("div", { className: styles.tagSettingContainer },
            React.createElement("div", { className: styles.tagSetting },
                React.createElement("div", { className: styles.tagSettingLabel }, "Industry"),
                React.createElement("div", { className: styles.tagSelectWrapper },
                    React.createElement(Select, { options: industryTagOptions, onChange: (selectedOptions) => {
                            const selectedTags = selectedOptions?.map((option) => option?.value);
                            const retTags = [...selectedTags, ...templateFunctionTags, ...templateTypeTags];
                            updateTemplateWizard("tags", retTags);
                        }, menuPlacement: "bottom", value: industryTagOptions.filter((option) => tryTemplate?.wizard?.tags?.includes(option?.value)), isMulti: true, placeholder: "Select Industries...", style: { width: "100%" } }))),
            React.createElement("div", { className: styles.tagSetting },
                React.createElement("div", { className: styles.tagSettingLabel }, "Function"),
                React.createElement("div", { className: styles.tagSelectWrapper },
                    React.createElement(Select, { options: functionTagOptions, onChange: (selectedOptions) => {
                            const selectedTags = selectedOptions?.map((option) => option?.value);
                            const retTags = [...templateIndustryTags, ...selectedTags, ...templateTypeTags];
                            updateTemplateWizard("tags", retTags);
                        }, menuPlacement: "bottom", value: functionTagOptions.filter((option) => tryTemplate?.wizard?.tags?.includes(option?.value)), isMulti: true, placeholder: "Select Functions...", style: { width: "100%" } }))),
            React.createElement("div", { className: styles.tagSetting },
                React.createElement("div", { className: styles.tagSettingLabel }, "Type"),
                React.createElement("div", { className: styles.tagSelectWrapper },
                    React.createElement(Select, { options: typeTagOptions, onChange: (selectedOptions) => {
                            const selectedTags = selectedOptions?.map((option) => option?.value);
                            const retTags = [...templateIndustryTags, ...templateFunctionTags, ...selectedTags];
                            updateTemplateWizard("tags", retTags);
                        }, menuPlacement: "bottom", value: typeTagOptions.filter((option) => tryTemplate?.wizard?.tags?.includes(option?.value)), isMulti: true, placeholder: "Select Types...", style: { width: "100%" } }))))));
};
const PerformanceStep = ({ tryTemplate, updateTemplateWizard }) => {
    const cloudLocation = tryTemplate?.wizard?.cloudLocation;
    const updateCloudLocation = (value) => {
        updateTemplateWizard("cloudLocation", value);
    };
    useEffect(() => {
        if (tryTemplate?.wizard?.provisionLocation !== "On Cloud") {
            updateCloudLocation(undefined);
        }
    }, [tryTemplate?.wizard?.provisionLocation]);
    const useHpeDeployOptions = isEnabled("use-hpe-deploy-options");
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.settingSubtitle, style: { marginTop: "0px", marginBottom: "6px" } }, "Where are you deploying this agent?"),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { active: tryTemplate?.wizard?.provisionLocation === "Near Edge" ||
                    tryTemplate?.wizard?.provisionLocation === "Far Edge", onClick: () => updateTemplateWizard("provisionLocation", "Near Edge"), className: styles.locationButton },
                React.createElement("div", { className: styles.provisionButtonWrapper },
                    React.createElement("div", { className: styles.provisionLocationIconContainer },
                        React.createElement("img", { src: useHpeDeployOptions ? IconHPE : MicrochipIcon, className: styles.cIconSmall, style: useHpeDeployOptions ? undefined : { maxHeight: "26px" } })),
                    React.createElement("div", { className: styles.bFlex }, useHpeDeployOptions ? "ProLiant (Edge)" : "Edge"),
                    React.createElement("div", { className: styles.buttonContent },
                        React.createElement("div", { className: styles.buttonItem },
                            React.createElement("div", null, "PRIVACY"),
                            React.createElement("div", { className: styles.buttonBadge, style: {
                                    background: "#008273",
                                    color: "white",
                                    border: "2px solid #008273"
                                } }, "HIGHEST")),
                        React.createElement("div", { className: styles.buttonItem },
                            React.createElement("div", null, "APP LATENCY"),
                            React.createElement("div", { className: styles.buttonBadge, style: {
                                    background: "#008273",
                                    color: "white",
                                    border: "2px solid #008273"
                                } }, "FASTEST")),
                        !isEnabled("use-hpe-deploy-options") && (React.createElement("div", { className: styles.buttonItem },
                            React.createElement("div", null, "COST"),
                            React.createElement("div", { className: styles.buttonBadge, style: {
                                    background: "#008273",
                                    color: "white",
                                    border: "2px solid #008273"
                                } }, "LOWEST")))))),
            isEnabled("use-hpe-deploy-options") ? (React.createElement(Button, { active: tryTemplate?.wizard?.provisionLocation === "DGX Cloud", onClick: () => updateTemplateWizard("provisionLocation", "DGX Cloud"), className: styles.locationButton },
                React.createElement("div", { className: styles.provisionButtonWrapper },
                    React.createElement("div", { className: styles.provisionLocationIconContainer },
                        React.createElement("img", { src: IconHPE, className: styles.cIconSmall })),
                    React.createElement("div", { className: styles.bFlex }, "HP PCAI (Private Cloud)"),
                    React.createElement("div", { className: styles.buttonContent },
                        React.createElement("div", { className: styles.buttonItem },
                            React.createElement("div", null, "PRIVACY"),
                            React.createElement("div", { className: styles.buttonBadge, style: {
                                    background: "#008273",
                                    color: "white",
                                    border: "2px solid #008273"
                                } }, "HIGHEST")),
                        React.createElement("div", { className: styles.buttonItem },
                            React.createElement("div", null, "APP LATENCY"),
                            React.createElement("div", { className: styles.buttonBadge, style: { border: "2px solid #34D399", background: "#FFFFFF" } }, "FAST")))))) : (React.createElement(Button, { active: tryTemplate?.wizard?.provisionLocation === "DGX Cloud", onClick: () => updateTemplateWizard("provisionLocation", "DGX Cloud"), className: styles.locationButton },
                React.createElement("div", { className: styles.provisionButtonWrapper },
                    React.createElement("div", { className: styles.provisionLocationIconContainer },
                        React.createElement("img", { src: CloudIcon, className: styles.cIconSmall, style: { maxHeight: "26px" } })),
                    React.createElement("div", { className: styles.bFlex }, "Private Cloud"),
                    React.createElement("div", { className: styles.buttonContent },
                        React.createElement("div", { className: styles.buttonItem },
                            React.createElement("div", null, "PRIVACY"),
                            React.createElement("div", { className: styles.buttonBadge, style: { border: "2px solid #34D399", background: "#FFFFFF" } }, "HIGH")),
                        React.createElement("div", { className: styles.buttonItem },
                            React.createElement("div", null, "APP LATENCY"),
                            React.createElement("div", { className: styles.buttonBadge, style: { border: "2px solid #34D399", background: "#FFFFFF" } }, "FAST")),
                        React.createElement("div", { className: styles.buttonItem },
                            React.createElement("div", null, "COST"),
                            React.createElement("div", { className: styles.buttonBadge, style: {
                                    background: "#008273",
                                    color: "white",
                                    border: "2px solid #008273"
                                } }, "LOWEST")))))),
            React.createElement(Button, { active: tryTemplate?.wizard?.provisionLocation === "On Cloud", onClick: () => updateTemplateWizard("provisionLocation", "On Cloud"), className: styles.locationButton },
                React.createElement("div", { className: styles.provisionButtonWrapper },
                    React.createElement("div", { className: styles.provisionLocationIconContainer },
                        React.createElement("img", { src: GCPIcon, className: styles.cIconSmall }),
                        React.createElement("img", { src: AWSIconSmall, className: styles.cIconSmall }),
                        React.createElement("img", { src: AzureIconSmall, className: styles.cIconSmall })),
                    React.createElement("div", { className: styles.bFlex }, "Cloud"),
                    React.createElement("div", { className: styles.buttonContent },
                        React.createElement("div", { className: styles.buttonItem },
                            React.createElement("div", null, "PRIVACY"),
                            React.createElement("div", { className: styles.buttonBadge, style: { background: "#FFFFFF", border: "2px solid #FF8E8C" } }, "LOWER")),
                        React.createElement("div", { className: styles.buttonItem },
                            React.createElement("div", null, "APP LATENCY"),
                            React.createElement("div", { className: styles.buttonBadge, style: { background: "#FF8E8C", border: "2px solid #FF8E8C" } }, "SLOWEST")),
                        !isEnabled("use-hpe-deploy-options") && (React.createElement("div", { className: styles.buttonItem },
                            React.createElement("div", null, "COST"),
                            React.createElement("div", { className: styles.buttonBadge, style: { background: "#FF8E8C", border: "2px solid #FF8E8C" } }, "HIGHEST"))))))),
        tryTemplate?.wizard?.provisionLocation === "On Cloud" && (React.createElement("div", null,
            React.createElement("div", { className: styles.settingSubtitle, style: { marginTop: "32px", marginBottom: "6px" } }, "Select your cloud provider"),
            React.createElement("div", { style: { display: "flex" } },
                React.createElement(Button, { style: { marginRight: "8px" }, active: cloudLocation === "GCP", onClick: () => updateCloudLocation("GCP") },
                    React.createElement("img", { src: GCPIcon, className: styles.cIconSmall }),
                    "GCP"),
                React.createElement(Button, { style: { marginRight: "8px" }, active: cloudLocation === "AWS", onClick: () => updateCloudLocation("AWS") },
                    React.createElement("img", { src: AWSIconSmall, className: styles.cIconSmall }),
                    "AWS"),
                React.createElement(Button, { style: { marginRight: "8px" }, active: cloudLocation === "AZURE", onClick: () => updateCloudLocation("AZURE") },
                    React.createElement("img", { src: AzureIconSmall, className: styles.cIconSmall }),
                    "AZURE")))),
        React.createElement("div", { className: styles.settingSubtitle, style: { marginTop: "32px", marginBottom: "6px" } }, "Which processors are you running?"),
        React.createElement("div", { className: styles.skipInfo }, "We will leverage a combination of models that can run optimally in that environment."),
        React.createElement("div", { className: styles.tOptionButtons },
            ((!isEnabled("use-hpe-deploy-options") && tryTemplate?.wizard?.provisionLocation === "DGX Cloud") ||
                tryTemplate?.wizard?.provisionLocation === "On Cloud") && (React.createElement(React.Fragment, null,
                React.createElement(Button, { className: styles.chipButtonShort, active: tryTemplate?.wizard?.processorType === "H100", onClick: () => updateTemplateWizard("processorType", "H100") },
                    React.createElement("img", { src: IconVideoChip }),
                    React.createElement("div", { className: styles.chipLabel }, "H100")))),
            (tryTemplate?.wizard?.provisionLocation === "Near Edge" ||
                (isEnabled("use-hpe-deploy-options") && tryTemplate?.wizard?.provisionLocation === "DGX Cloud")) && (React.createElement(React.Fragment, null, isEnabled("use-hpe-deploy-options") ? (React.createElement(React.Fragment, null,
                React.createElement(Button, { active: tryTemplate?.wizard?.processorType === "Grace Hopper 200", onClick: () => updateTemplateWizard("processorType", "Grace Hopper 200"), className: styles.chipButton, disabled: isEnabled("use-hpe-deploy-options") && tryTemplate?.wizard?.provisionLocation === "DGX Cloud" },
                    React.createElement("img", { src: IconVideoChip }),
                    React.createElement("div", { className: styles.chipLabel }, "Grace Hopper 200")),
                React.createElement(Button, { className: styles.chipButton, active: tryTemplate?.wizard?.processorType === "H100", onClick: () => updateTemplateWizard("processorType", "H100") },
                    React.createElement("img", { src: IconVideoChip }),
                    React.createElement("div", { className: styles.chipLabel }, "H100")),
                React.createElement(Button, { className: styles.chipButton, active: tryTemplate?.wizard?.processorType === "4xL40S", onClick: () => updateTemplateWizard("processorType", "4xL40S") },
                    React.createElement("img", { src: IconVideoChip }),
                    React.createElement("div", { className: styles.chipLabel }, "4xL40S")))) : (React.createElement(React.Fragment, null,
                React.createElement(Button, { active: tryTemplate?.wizard?.processorType === "Grace Hopper 200", onClick: () => updateTemplateWizard("processorType", "Grace Hopper 200"), className: styles.chipButton },
                    React.createElement("img", { src: IconVideoChip }),
                    React.createElement("div", { className: styles.chipLabel }, "Grace Hopper 200")),
                React.createElement(Button, { className: styles.chipButton, disabled: true },
                    React.createElement("div", { className: styles.comingSoonBadge }, "COMING SOON!"),
                    React.createElement("img", { src: IconVideoChipGray }),
                    React.createElement("div", { className: styles.chipLabel }, "Grace Blackwell 10 (Digits)")),
                React.createElement(Button, { className: styles.chipButton, disabled: true },
                    React.createElement("div", { className: styles.comingSoonBadge }, "COMING SOON!"),
                    React.createElement("img", { src: IconVideoChipGray }),
                    React.createElement("div", { className: styles.chipLabel }, "Grace Blackwell 200"))))))),
        React.createElement("div", { className: styles.settingSubtitle, style: { marginTop: "32px", marginBottom: "6px" } }, "What is more important for you?"),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { active: tryTemplate?.wizard?.performanceType === "Accuracy", style: { minWidth: "132px" }, onClick: () => updateTemplateWizard("performanceType", "Accuracy") },
                React.createElement("img", { src: IconAccuracy, style: { marginRight: "5px" } }),
                "Accuracy"),
            React.createElement(Button, { active: tryTemplate?.wizard?.performanceType === "Performance", style: { minWidth: "132px" }, onClick: () => updateTemplateWizard("performanceType", "Performance") },
                React.createElement("img", { src: IconPerformance, style: { marginRight: "5px" } }),
                "Performance"))));
};
const BrandingStep = ({ tryTemplate, updateTemplateWizard }) => {
    const dispatch = useDispatch();
    const handleImageUpload = (e, callback) => {
        const fileSize = e.target.files[0]?.size;
        if (fileSize > CHATAPP_IMAGE_SIZE) {
            const message = `The image you uploaded was ${formatBytes(fileSize)}. Please upload an image smaller than 500KB.`;
            toast(message, {
                type: toast.TYPE.ERROR,
                position: toast.POSITION.TOP_CENTER,
                autoClose: 7500
            });
            e.target.value = null;
            return;
        }
        const reader = new FileReader();
        reader.onloadend = () => {
            callback(reader.result);
        };
        reader.readAsDataURL(e.target.files[0]);
    };
    const handleLogoChange = (e) => {
        const callback = (value) => {
            dispatch(chatGPTReducer.updateBase64StringLogo(value));
            updateTemplateWizard("base64StringLogo", value);
        };
        return handleImageUpload(e, callback);
    };
    const handleBotChange = (e) => {
        const callback = (value) => {
            dispatch(chatGPTReducer.updateBase64StringBot(value));
            updateTemplateWizard("base64StringBot", value);
        };
        return handleImageUpload(e, callback);
    };
    const [headerColor, setHeaderColor] = useState(tryTemplate?.wizard?.headerColor ?? "#401570");
    const [editHeaderColor, setEditHeaderColor] = useState(false);
    const headerDarkMode = useSelector((state) => chatGPTReducer.getHeaderDarkMode(state));
    const [linkColor, setLinkColor] = useState(tryTemplate?.wizard?.linkColor ?? "#8556EB");
    const [editLinkColor, setEditLinkColor] = useState(false);
    const linkColorDarkMode = useSelector((state) => chatGPTReducer.getLinkColorDarkMode(state));
    const [chatButtonColor, setChatButtonColor] = useState(tryTemplate?.wizard?.chatButtonColor ?? "#FB813C");
    const [editChatButtonColor, setEditChatButtonColor] = useState(false);
    const chatButtonDarkMode = useSelector((state) => chatGPTReducer.getChatButtonDarkMode(state));
    const [backgroundColor, setBackgroundColor] = useState(tryTemplate?.wizard?.backgroundColor ?? "#FFFFFF");
    const [editBackgroundColor, setEditBackgroundColor] = useState(false);
    const backgroundColorDarkMode = useSelector((state) => chatGPTReducer.getBackgroundColorDarkMode(state));
    const closeAllColorPickers = () => {
        setEditHeaderColor(false);
        setEditLinkColor(false);
        setEditChatButtonColor(false);
        setEditBackgroundColor(false);
    };
    return (React.createElement("div", null,
        React.createElement("div", { style: { display: "flex", alignItems: "center", marginBottom: "16px" } },
            React.createElement("div", { className: styles.cSetting, style: { marginRight: "32px" } },
                React.createElement("div", { className: styles.subTitle }, "Logo"),
                tryTemplate?.wizard?.base64StringLogo !== "" && (React.createElement("img", { src: tryTemplate?.wizard?.base64StringLogo, className: styles.viewImage })),
                React.createElement("input", { style: { marginTop: "4px" }, type: "file", accept: ".png", onChange: handleLogoChange })),
            React.createElement("div", { className: styles.cSetting },
                React.createElement("div", { className: styles.subTitle }, "ChatBot Image"),
                tryTemplate?.wizard?.base64StringBot !== "" && (React.createElement("img", { src: tryTemplate?.wizard?.base64StringBot, className: styles.viewImage })),
                React.createElement("input", { style: { marginTop: "4px" }, type: "file", accept: ".png", onChange: handleBotChange }))),
        React.createElement("div", { style: { marginBottom: "20px" } },
            React.createElement("div", { className: styles.subTitle, style: { fontSize: "16px" } }, "Brand Colors"),
            React.createElement("div", { className: styles.colorSettings },
                React.createElement("div", { className: styles.colorSetting },
                    React.createElement("div", { className: styles.colorTop, onClick: () => {
                            closeAllColorPickers();
                            setEditHeaderColor(!editHeaderColor);
                        } },
                        React.createElement("div", { className: styles.colorSubTitle }, "Header Color"),
                        React.createElement("div", { className: styles.showColor, style: { backgroundColor: headerColor } }),
                        React.createElement(LineInput, { value: headerColor, onChange: (val) => {
                                setHeaderColor(val);
                                dispatch(chatGPTReducer.updateHeaderColor(val));
                                updateTemplateWizard("headerColor", val);
                            }, updateInstant: true, style: {
                                marginLeft: "12px"
                            }, inputClassName: styles.colorPickerInput })),
                    React.createElement("div", { className: styles.darkModeToggleWrapper },
                        React.createElement(LabeledToggle, { style: {
                                display: "block"
                            }, checked: headerDarkMode, onChange: () => {
                                const retVal = headerDarkMode !== true;
                                dispatch(chatGPTReducer.updateHeaderDarkMode(retVal));
                                updateTemplateWizard("headerDarkMode", retVal);
                            }, isAibleColors: true }),
                        React.createElement("div", { className: styles.darkModeToggleLabel }, "Reverse Content Color")),
                    editHeaderColor && (React.createElement("div", { className: styles.colorPickerWrapper + " colorPickerWrapper" },
                        React.createElement("div", { className: styles.colorPickerLabel },
                            "Custom Color",
                            React.createElement("a", { className: styles.colorPickerClose, onClick: () => closeAllColorPickers() }, "✕")),
                        React.createElement(HexColorPicker, { color: headerColor, onChange: (val) => {
                                setHeaderColor(val);
                                dispatch(chatGPTReducer.updateHeaderColor(val));
                                updateTemplateWizard("headerColor", val);
                            } })))),
                React.createElement("div", { className: styles.colorSetting },
                    React.createElement("div", { className: styles.colorTop, onClick: () => {
                            closeAllColorPickers();
                            setEditLinkColor(!editLinkColor);
                        } },
                        React.createElement("div", { className: styles.colorSubTitle }, "Link, Accent and Chatbot Color"),
                        React.createElement("div", { className: styles.showColor, style: { backgroundColor: linkColor } }),
                        React.createElement(LineInput, { value: linkColor, onChange: (val) => {
                                setLinkColor(val);
                                dispatch(chatGPTReducer.updateLinkColor(val));
                                updateTemplateWizard("linkColor", val);
                            }, updateInstant: true, style: {
                                marginLeft: "12px"
                            }, inputClassName: styles.colorPickerInput })),
                    React.createElement("div", { className: styles.darkModeToggleWrapper },
                        React.createElement(LabeledToggle, { style: {
                                display: "block"
                            }, checked: linkColorDarkMode, onChange: () => {
                                const retVal = linkColorDarkMode !== true;
                                dispatch(chatGPTReducer.updateLinkColorDarkMode(retVal));
                                updateTemplateWizard("linkColorDarkMode", retVal);
                            }, isAibleColors: true }),
                        React.createElement("div", { className: styles.darkModeToggleLabel }, "Reverse Content Color")),
                    editLinkColor && (React.createElement("div", { className: styles.colorPickerWrapper + " colorPickerWrapper" },
                        React.createElement("div", { className: styles.colorPickerLabel },
                            "Custom Color",
                            React.createElement("a", { className: styles.colorPickerClose, onClick: () => closeAllColorPickers() }, "✕")),
                        React.createElement(HexColorPicker, { color: linkColor, onChange: (val) => {
                                setLinkColor(val);
                                dispatch(chatGPTReducer.updateLinkColor(val));
                                updateTemplateWizard("linkColor", val);
                            } })))),
                React.createElement("div", { className: styles.colorSetting },
                    React.createElement("div", { className: styles.colorTop, onClick: () => {
                            closeAllColorPickers();
                            setEditChatButtonColor(!editChatButtonColor);
                        } },
                        React.createElement("div", { className: styles.colorSubTitle }, "Chat Button Color"),
                        React.createElement("div", { className: styles.showColor, style: { backgroundColor: chatButtonColor } }),
                        React.createElement(LineInput, { value: chatButtonColor, onChange: (val) => {
                                setChatButtonColor(val);
                                dispatch(chatGPTReducer.updateChatButtonColor(val));
                                updateTemplateWizard("chatButtonColor", val);
                            }, updateInstant: true, style: {
                                marginLeft: "12px"
                            }, inputClassName: styles.colorPickerInput })),
                    React.createElement("div", { className: styles.darkModeToggleWrapper },
                        React.createElement(LabeledToggle, { style: {
                                display: "block"
                            }, checked: chatButtonDarkMode, onChange: () => {
                                const retVal = chatButtonDarkMode !== true;
                                dispatch(chatGPTReducer.updateChatButtonDarkMode(retVal));
                                updateTemplateWizard("chatButtonDarkMode", retVal);
                            }, isAibleColors: true }),
                        React.createElement("div", { className: styles.darkModeToggleLabel }, "Reverse Content Color")),
                    editChatButtonColor && (React.createElement("div", { className: styles.colorPickerWrapper + " colorPickerWrapper" },
                        React.createElement("div", { className: styles.colorPickerLabel },
                            "Custom Color",
                            React.createElement("a", { className: styles.colorPickerClose, onClick: () => closeAllColorPickers() }, "✕")),
                        React.createElement(HexColorPicker, { color: chatButtonColor, onChange: (val) => {
                                setChatButtonColor(val);
                                dispatch(chatGPTReducer.updateChatButtonColor(val));
                                updateTemplateWizard("chatButtonColor", val);
                            } })))),
                React.createElement("div", { className: styles.colorSetting },
                    React.createElement("div", { className: styles.colorTop, onClick: () => {
                            closeAllColorPickers();
                            setEditBackgroundColor(!editBackgroundColor);
                        } },
                        React.createElement("div", { className: styles.colorSubTitle }, "Background Color"),
                        React.createElement("div", { className: styles.showColor, style: { backgroundColor: backgroundColor } }),
                        React.createElement(LineInput, { value: backgroundColor, onChange: (val) => {
                                setBackgroundColor(val);
                                dispatch(chatGPTReducer.updateBackgroundColor(val));
                                updateTemplateWizard("backgroundColor", val);
                            }, updateInstant: true, style: {
                                marginLeft: "12px"
                            }, inputClassName: styles.colorPickerInput })),
                    React.createElement("div", { className: styles.darkModeToggleWrapper },
                        React.createElement(LabeledToggle, { style: {
                                display: "block"
                            }, checked: backgroundColorDarkMode, onChange: () => {
                                const retVal = backgroundColorDarkMode !== true;
                                dispatch(chatGPTReducer.updateBackgroundColorDarkMode(retVal));
                                updateTemplateWizard("backgroundColorDarkMode", retVal);
                            }, isAibleColors: true }),
                        React.createElement("div", { className: styles.darkModeToggleLabel }, "Reverse Content Color")),
                    editBackgroundColor && (React.createElement("div", { className: styles.colorPickerWrapper + " colorPickerWrapper" },
                        React.createElement("div", { className: styles.colorPickerLabel },
                            "Custom Color",
                            React.createElement("a", { className: styles.colorPickerClose, onClick: () => closeAllColorPickers() }, "✕")),
                        React.createElement(HexColorPicker, { color: backgroundColor, onChange: (val) => {
                                setBackgroundColor(val);
                                dispatch(chatGPTReducer.updateBackgroundColor(val));
                                updateTemplateWizard("backgroundColor", val);
                            } }))))))));
};
const BackWarningModal = ({ showModal, updateShowModal, onConfirm }) => (React.createElement(Dialog, { open: showModal, onOpenChange: () => updateShowModal(false) },
    React.createElement(DialogContent, null,
        React.createElement(DialogHeader, null,
            React.createElement(DialogTitle, null, "Any unsaved work will be lost")),
        "Are you sure you want to go back to all templates?",
        React.createElement(DialogFooter, null,
            React.createElement(Button, { onClick: () => updateShowModal(false) }, "Cancel"),
            React.createElement(Button, { onClick: () => onConfirm() }, "Yes, go to templates")))));
const ConfigureSetupModal = ({ blueprintId, showTemplateSetup, setShowTemplateSetup, tryTemplate, updateTemplateWizard, handleSaveTemplate, defaultDatasetId, defaultArtifactId }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const chatApp = useSelector((state) => chatGPTReducer.getChatApp(state));
    const chatAppWizard = chatApp?.wizard;
    const retLogo = chatAppWizard?.base64StringBot ?? tryTemplate?.wizard?.base64StringBot;
    // This determines whether to foce a KPI Analysis when finishing the setup
    const [isKPIAnalysisReady, setIsKPIAnalysisReady] = useState(true);
    // Adding a state to check if app has started intializing
    const [hasStartedInitialize, updateHasStartedInitialize] = useState(false);
    const [isCreatingAgent, updateIsCreatingAgent] = useState(false);
    const [agentName, setAgentName] = useState(tryTemplate?.name);
    const [isDefaultName, setIsDefaultName] = useState(true);
    const [currentLabelColumn, setCurrentLabelColumn] = useState("");
    const [isKPIIdentical, setIsKPIIdentical] = useState(true);
    const [editSuggestDesc, updateEditSuggestDesc] = useState(false);
    const [promptSuggestDesc, updatePromptSuggestDesc] = useState(DEFAULT_DESCRIPTION_SUGGESTION_PROMPT);
    const [isSuggestDesc, updateIsSuggestDesc] = useState(false);
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const isKPIAnalysis = useSelector((state) => chatAppReducer.getIsKPIAnalysis(state));
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const isProcessing = dataset?.status_name !== "DONE";
    const isError = dataset?.dataset_status === "ERROR";
    const isLoading = isProcessing && !isError;
    const artifactId = useSelector((state) => chatGPTReducer.getArtifactId(state));
    const projectId = useSelector((state) => chatGPTReducer.getProjectId(state));
    const artifact = useSelector((state) => languageModelArtifactReducer.getCorpus(state, artifactId ?? -1));
    const comparisonOptions = useSelector((state) => nextReducer.getComparisonOptions(state, nextId));
    const hasExplore = useSelector((state) => nextReducer.getHasExplore(state, nextId));
    const shouldHaveExplore = !isKPIAnalysis && (chatType === "AIBLE" || chatType === "WHATS_CHANGED");
    const isWhatsChanged = chatType === "WHATS_CHANGED";
    const isDocumentSummarization = blueprintId === "CHATAIBLE_DOCUMENT_SUMMARIZATION" || chatType === "DOCUMENT";
    const isAgenticChat = chatType === "AIBLE";
    const isNLQ = chatType === "SQL";
    const dateColumn = useSelector((state) => homeReducer.getKPIAnalysisDateColumn(state, datasetId));
    const timeBucket = useSelector((state) => homeReducer.getKPIAnalysisTimeBucket(state, datasetId));
    const KPISegment = useSelector((state) => homeReducer.getKPIAnalysisSegment(state, datasetId));
    const KPISubsegment = useSelector((state) => homeReducer.getKPIAnalysisSubsegment(state, datasetId));
    const KPIDateRange = useSelector((state) => homeReducer.getKPIDateRange(state, datasetId));
    const KPIColumns = useSelector((state) => homeReducer.getKPIColumns(state, datasetId));
    const reports = useSelector((state) => reportReducer.getReports(state));
    // Optimize variables
    // create the setup from the user selections and the saved optimize on the chatapp
    const optimizeSetup = useSelector((state) => {
        if (chatType !== "OPTIMIZE") {
            return undefined;
        }
        const savedOptimize = chatGPTReducer.getOptimizeSetup(state);
        return {
            ...(savedOptimize ?? {}),
            ...(tryTemplate?.wizard?.optimizeSetup ?? {})
        };
    });
    // Get the optimize blueprints
    const blueprints = useSelector((state) => viewReducer.getBlueprints(state));
    const blueprintOptions = (blueprints ?? []).map((d) => ({ value: d.id, label: d.name }));
    // Find the selected blueprint
    const selectedBlueprint = optimizeSetup?.blueprintId
        ? blueprints.find((d) => d.id === optimizeSetup?.blueprintId)
        : undefined;
    // Get the currently selected runId (generally gonna be "new")
    const optimizeProjectId = optimizeSetup?.projectId ?? "new";
    const optimized = useSelector((state) => projectReducer.getOptimized(state, optimizeProjectId));
    const runId = optimized?.innerId ?? optimizeSetup?.runId ?? "new";
    const hasAllInput = dateColumn !== undefined && timeBucket !== undefined && KPISegment !== undefined;
    const retComparisonOptions = {
        ...KPIDateRange,
        ...comparisonOptions
    };
    if (!retComparisonOptions.dateField) {
        if (dateColumn) {
            retComparisonOptions.dateField = dateColumn;
        }
        else if (dataset?.options?.timestamp_column) {
            retComparisonOptions.dateField = dataset?.options?.timestamp_column;
        }
    }
    const appInitSummarize = useSelector((state) => chatGPTReducer.getAppInitSummarize(state));
    const isBenchmark = useSelector((state) => chatGPTReducer.getIsBenchmark(state));
    const blueprint = useSelector((state) => blueprintReducer.getBlueprint(state, blueprintId));
    const initialDescription = blueprint?.wizard?.description;
    const isValidChatApp = blueprint && blueprint?.wizard?.isChatApp === true;
    const startInDashboard = useSelector((state) => chatAppReducer.getStartInDashboard(state));
    const isKpiDriversTemplate = isWhatsChanged &&
        (blueprint?.wizard?.templateType === "KPI_DRIVERS" || blueprint?.wizard?.templateType !== "WHATS_CHANGED_KPI");
    const datasetDateField = dataset?.options?.timestamp_column;
    const isDatasetChat = isWhatsChanged || isAgenticChat || isKpiDriversTemplate || chatType === "NLQ" || chatType === "BENCHMARK";
    let isSetupReady = true;
    // If the linked dataset is still processing, setup isn't ready
    if (datasetId && dataset?.id) {
        if (isLoading) {
            isSetupReady = false;
        }
    }
    else if (isDatasetChat) {
        isSetupReady = false;
    }
    // check case when Agentic analytics templates don't have evaluated KPI
    if (isAgenticChat && !dataset?.outcome) {
        isSetupReady = false;
    }
    // If we're in what's changed, make sure the date and date ranges are set
    // Note that created KPI overview agents show up as agents with KPI_ANALYSIS usecases
    if (isWhatsChanged) {
        if (!retComparisonOptions?.dateField ||
            !retComparisonOptions?.currentStart ||
            // Also check if there's a dataset saved date field and disable if the selected date option needs re-analysis
            comparisonOptions?.dateField !== datasetDateField ||
            // Also disable it's a KPI deep dive and there's not outcome selected
            (!isKpiDriversTemplate && !dataset?.outcome)) {
            isSetupReady = false;
        }
    }
    // If we're in kpi analysis, wait for reevalutate and make sure all fields are in
    if (isKPIAnalysis && (!isKPIAnalysisReady || !hasAllInput)) {
        isSetupReady = false;
    }
    if (isBenchmark && !dataset?.outcome) {
        isSetupReady = false;
    }
    const chatAppIsInitializing = useSelector((state) => chatGPTReducer.getChatAppIsInitializing(state));
    const isInitializing = isValidChatApp && (!hasStartedInitialize || chatAppIsInitializing);
    useEffect(() => {
        if (!hasStartedInitialize && chatAppIsInitializing) {
            updateHasStartedInitialize(true);
        }
    }, [chatAppIsInitializing]);
    const optimizeReports = reports?.filter((report) => report?.metadata?.explorations?.[0]?.projectId !== undefined);
    const linkedOptimizeReportOptions = optimizeReports?.map((report) => {
        return {
            label: report?.metadata?.explorations?.[0]?.reportLabel ?? report?.name,
            value: report?.id,
            datasetId: report?.metadata?.explorations?.[0]?.datasetId
        };
    });
    const selectedLinkedOptimizeReport = linkedOptimizeReportOptions?.find((report) => report?.value === tryTemplate?.wizard?.linkedOptimizeReport?.reportId);
    const handleUpdateTemplateDeepDiveLabel = (column, key, val) => {
        const currLabels = tryTemplate?.wizard?.autoDeepDiveCustomLabels ?? {};
        const newLabels = {
            ...currLabels,
            [column]: {
                ...(currLabels?.[column] || {}),
                [key]: val
            }
        };
        updateTemplateWizard("autoDeepDiveCustomLabels", newLabels);
    };
    const handleTryAgent = () => {
        setShowTemplateSetup(false);
    };
    const handleCreateAgent = async () => {
        updateIsCreatingAgent(true);
        if (isWhatsChanged && !isKPIAnalysis) {
            dispatch(globalReducer.updateIsOpeningComparison(true));
            dispatch(nextReducer.updateComparisonOptions(nextId, retComparisonOptions));
            const newAppId = await handleSaveTemplate(true, agentName, isKPIIdentical);
            history.push("/next/new/new/" + newAppId);
            dispatch(chatGPTReducer.initChatAppHelper(newAppId));
            //history.push("/next/" + datasetId + "/new/" + blueprintId);
            dispatch(globalReducer.updateIsOpeningComparison(false));
            updateIsCreatingAgent(false);
            return Promise.resolve();
        }
        if (isBenchmark && dataset) {
            const newAppId = await handleSaveTemplate(true, agentName);
            dispatch(nextReducer.openBenchmark(newAppId));
            updateIsCreatingAgent(false);
            return Promise.resolve();
        }
        if (datasetId) {
            if (!dataset && !isNaN(Number(datasetId))) {
                dispatch(homeReducer.fetchDataset(datasetId, false, true));
            }
            if (!hasExplore && shouldHaveExplore) {
                dispatch(chatGPTReducer.updateShouldInit(true));
            }
        }
        if (isKPIAnalysis && isKPIAnalysisReady) {
            // When finishing the setup, update the comparison options with our default fallbacks
            // This should ideally be something set in the fetch comparison options function, but...
            dispatch(nextReducer.updateComparisonOptions(nextId, retComparisonOptions));
            dispatch(chatGPTReducer.selectBlueprint("CHATAIBLE_KPI_ANALYSIS"));
            dispatch(globalReducer.updateIsSkipChatGPTReset(true));
            // Set startInDashboard as true for all KPI Overview
            if (startInDashboard !== true) {
                dispatch(chatAppReducer.updateStartInDashboard(true));
            }
            dispatch(homeReducer.updateKPIDateRange(datasetId, retComparisonOptions));
        }
        const newAppId = await handleSaveTemplate(true, agentName);
        history.push("/next/new/new/" + newAppId);
        return Promise.resolve();
    };
    useEffect(() => {
        if (!isDefaultName) {
            return;
        }
        let newAgentName = tryTemplate?.name;
        if (dataset?.name && (isAgenticChat || isKpiDriversTemplate || isWhatsChanged || isNLQ || isBenchmark)) {
            newAgentName = `${dataset?.name}, ${newAgentName}`;
        }
        if (dataset?.outcome && (isAgenticChat || isKpiDriversTemplate || isBenchmark)) {
            newAgentName = `${dataset?.outcome}, ${newAgentName}`;
        }
        if (artifact?.name && isDocumentSummarization) {
            newAgentName = `${artifact?.name}, ${newAgentName}`;
        }
        setAgentName(newAgentName);
    }, [artifactId, datasetId, dataset?.outcome]);
    console.log("what is blueprint", blueprint);
    const KPIDeepDiveExcludeColumns = useSelector((state) => chatGPTReducer.getKPIDeepDiveExcludeColumns(state, datasetId));
    const updateKPIDeepDiveExcludeColumns = (data) => dispatch(chatGPTReducer.updateKPIDeepDiveExcludeColumns(datasetId, data));
    const KPIDeepDiveExcludeColumnOptions = useSelector((state) => homeReducer.getKPIAnalysisDeepDiveExcludeColumnOptions(state, datasetId));
    const originalKPIOptions = useRef(KPIDeepDiveExcludeColumnOptions);
    useEffect(() => {
        originalKPIOptions.current = KPIDeepDiveExcludeColumnOptions;
        setIsKPIIdentical(true);
    }, [datasetId]);
    useEffect(() => {
        const isIdentical = isArrEqual((originalKPIOptions.current ?? []).slice().sort(), (KPIDeepDiveExcludeColumnOptions ?? []).slice().sort());
        setIsKPIIdentical(isIdentical);
    }, [KPIDeepDiveExcludeColumnOptions]);
    const isReportsLoading = useSelector((state) => globalReducer.getIsReportsLoading(state));
    return blueprintId === "CHATAIBLE_AGENT_C" || blueprint?.wizard?.aibleAnywhere?.isAgentC === true ? (React.createElement(AgentCModal, { agent: blueprint?.wizard?.aibleAnywhere ?? undefined, open: showTemplateSetup, onOpenChange: () => {
            if (chatType === "OPTIMIZE")
                return;
            setShowTemplateSetup(false);
        }, isNewCreate: true })) : (React.createElement(Dialog, { open: showTemplateSetup, onOpenChange: () => {
            if (chatType === "OPTIMIZE")
                return;
            setShowTemplateSetup(false);
        } },
        React.createElement(DialogContent, { size: "lg", showCloseButton: !(chatType === "OPTIMIZE") },
            React.createElement(DialogHeader, null,
                React.createElement("div", { className: styles.wizardHeader },
                    retLogo && retLogo?.length > 0 && (React.createElement("div", { className: styles.wizardHeaderLogoWrapper },
                        React.createElement("img", { className: styles.wizardHeaderLogo, src: retLogo }))),
                    React.createElement("div", { className: styles.wizardHeaderTextContent },
                        React.createElement("div", { className: styles.wizardTemplateName }, `${tryTemplate?.name ? tryTemplate?.name + " " : ""}Agent Setup`),
                        tryTemplate?.wizard?.tags && tryTemplate?.wizard?.tags?.length > 0 && (React.createElement("div", { className: styles.wizardTagsWrapper },
                            React.createElement("div", { className: styles.wizardLightText }, "Tags: "),
                            React.createElement("div", { className: styles.wizardTagsList }, tryTemplate?.wizard?.tags &&
                                tryTemplate.wizard.tags.map((tagId) => {
                                    return React.createElement(TemplateItemTag, { tagId: tagId, key: tagId });
                                }))))))),
            isValidChatApp && (!hasStartedInitialize || chatAppIsInitializing) ? (React.createElement("div", { className: styles.agentInitializingContent },
                React.createElement("div", { className: styles.agentInitializingLoadingWrapper },
                    React.createElement(LoadingIndicator, null)),
                React.createElement("div", { className: styles.agentInitializingText }, "Loading agent for setup..."))) : (React.createElement("div", { className: styles.configureWizardModalBody },
                chatType !== "PREDICT" && (React.createElement(DataSelectionStep, { blueprintId: blueprintId, setIsKPIAnalysisReady: setIsKPIAnalysisReady, defaultDatasetId: defaultDatasetId, defaultArtifactId: defaultArtifactId, hideDatesOutsideRange: Boolean(tryTemplate?.wizard?.hideDatesOutsideRange), updateHideDatesOutsideRange: (val) => updateTemplateWizard("hideDatesOutsideRange", val) })),
                chatType === "OPTIMIZE" && (React.createElement("div", { style: { marginBottom: "10px", marginTop: "-10px" } },
                    React.createElement("div", { className: styles.wizardBoldText }, "What business use case would you like to use (Optional)?"),
                    React.createElement(Select, { options: blueprintOptions, value: (blueprintOptions ?? []).find((d) => d.value === selectedBlueprint?.id), onChange: (d) => {
                            updateTemplateWizard("optimizeSetup", { ...(optimizeSetup ?? {}), blueprintId: d?.value });
                            dispatch(blueprintReducer.initBlueprint(d?.value, runId));
                        }, isClearable: true }))),
                chatType === "PREDICT" && (React.createElement("div", { style: { marginBottom: "10px", marginTop: "-10px" } },
                    React.createElement("div", { className: styles.wizardBoldText }, "What Optimize Project would you like to use?"),
                    React.createElement("div", { className: styles.projectSelectHolder },
                        React.createElement("div", { style: { width: "calc(100% - 120px)" } },
                            React.createElement(ProjectSelector, { projectId: projectId, onChange: (projectId) => dispatch(chatGPTReducer.updateProjectId(projectId)), menuPlacement: "bottom" })),
                        React.createElement(Button, { onClick: () => dispatch(reportReducer.fetchNextReports()), isLoading: isReportsLoading, disabled: isReportsLoading, style: { marginLeft: "20px", whiteSpace: "nowrap" } }, "Load More")))),
                chatType === "WHATS_CHANGED" &&
                    !isKPIAnalysis &&
                    !isKpiDriversTemplate &&
                    Boolean(comparisonOptions?.dateField) && (React.createElement("div", { className: styles.extraOptionsInputContainer },
                    React.createElement("div", { className: styles.wizardBoldText, style: { marginBottom: "8px" } }, "What labels would you like to use in your analysis?"),
                    React.createElement("div", { className: styles.extraOptionsMetricsLabels },
                        React.createElement(KPIMetricsLabels, { hideChangeInBehavior: tryTemplate?.wizard?.hideChangeInBehavior, hideChangeInPopulation: tryTemplate?.wizard?.hideChangeInPopulation, hideChangeInOutcome: tryTemplate?.wizard?.hideChangeInOutcome, hideChangeInTotalPopulation: tryTemplate?.wizard?.hideChangeInTotalPopulation, renameBehavior: tryTemplate?.wizard?.renameBehavior, renameOutcome: tryTemplate?.wizard?.renameOutcome, renamePopulation: tryTemplate?.wizard?.renamePopulation, renameTotalPopulation: tryTemplate?.wizard?.renameTotalPopulation, hideMissingInCharts: tryTemplate?.wizard?.hideMissingInCharts, hideOtherInCharts: tryTemplate?.wizard?.hideOtherInCharts, updateHideChangeInBehavior: (val) => updateTemplateWizard("hideChangeInBehavior", val), updateHideChangeInPopulation: (val) => updateTemplateWizard("hideChangeInPopulation", val), updateHideChangeInOutcome: (val) => updateTemplateWizard("hideChangeInOutcome", val), updateHideChangeInTotalPopulation: (val) => updateTemplateWizard("hideChangeInTotalPopulation", val), updateRenameBehavior: (val) => updateTemplateWizard("renameBehavior", val), updateRenameOutcome: (val) => updateTemplateWizard("renameOutcome", val), updateRenamePopulation: (val) => updateTemplateWizard("renamePopulation", val), updateRenameTotalPopulation: (val) => updateTemplateWizard("renameTotalPopulation", val), updateHideMissingInCharts: (val) => updateTemplateWizard("hideMissingInCharts", val), updateHideOtherInCharts: (val) => updateTemplateWizard("hideOtherInCharts", val) })))),
                isWhatsChanged && blueprint?.wizard?.templateType === "WHATS_CHANGED_KPI" && (React.createElement("div", { className: "mb-2.5" },
                    React.createElement("div", { className: "text-[14px] font-bold mb-1" }, "Which fields should be included in the deep dive?"),
                    React.createElement("div", { className: "text-[#7C7C7C]" }, "Changing these fields will generate a new analysis. Larger datasets may take longer to process."),
                    React.createElement(SettingsKPISelection, { value: KPIDeepDiveExcludeColumnOptions.filter((o) => !KPIDeepDiveExcludeColumns?.includes(o)), options: KPIDeepDiveExcludeColumnOptions, onChange: (v) => {
                            const exclude = KPIDeepDiveExcludeColumnOptions.filter((o) => !v.includes(o));
                            updateKPIDeepDiveExcludeColumns(exclude);
                        }, placeholder: "Select KPIs" }))),
                React.createElement("div", { style: { paddingBottom: "20px" } },
                    React.createElement("div", { className: styles.wizardBoldText, style: { marginBottom: "10px" } }, "Agent name"),
                    React.createElement("div", null,
                        React.createElement(LineInput, { value: agentName, onChange: (val) => {
                                if (val !== tryTemplate?.name) {
                                    setIsDefaultName(false);
                                }
                                setAgentName(val);
                            }, inputClassName: styles.wizardNameInput }))),
                React.createElement("div", { style: { paddingBottom: "20px" } },
                    React.createElement("div", { className: "flex items-end justify-between mb-[4px]" },
                        React.createElement("div", { className: styles.wizardBoldText }, "Agent Description"),
                        React.createElement("div", { className: "flex items-center" },
                            tryTemplate?.wizard?.description !== initialDescription && (React.createElement(Button, { onClick: () => updateTemplateWizard("description", initialDescription), disabled: isSuggestDesc, className: "mr-[4px]", isSmall: true },
                                React.createElement("img", { src: UndoArrowIcon, style: { width: "18px" } }))),
                            React.createElement(Button, { onClick: () => {
                                    updateEditSuggestDesc(!editSuggestDesc);
                                }, active: editSuggestDesc, className: "mr-[4px]", isSmall: true },
                                React.createElement("img", { src: EditIcon, style: { width: "18px" } })),
                            React.createElement(Button, { onClick: async () => {
                                    updateIsSuggestDesc(true);
                                    try {
                                        const suggestResponse = await dispatch(chatGPTReducer.askPromptSuggestAgentDescription(promptSuggestDesc, tryTemplate, agentName));
                                        if (suggestResponse) {
                                            updateTemplateWizard("description", suggestResponse);
                                        }
                                    }
                                    catch {
                                        console.log("Could not get a suggestion to update description");
                                    }
                                    updateIsSuggestDesc(false);
                                }, isLoading: isSuggestDesc, isSmall: true }, "Suggest Description"))),
                    React.createElement("div", null,
                        React.createElement("textarea", { className: styles.wizardDescriptionField, value: tryTemplate?.wizard?.description, onChange: (e) => {
                                updateTemplateWizard("description", e?.target?.value);
                            }, disabled: isSuggestDesc })),
                    editSuggestDesc && (React.createElement("div", null,
                        React.createElement("textarea", { className: styles.wizardDescriptionField, value: promptSuggestDesc, onChange: (e) => {
                                updatePromptSuggestDesc(e?.target?.value);
                            }, disabled: isSuggestDesc, style: { height: "160px" } })))),
                !isBenchmark && (React.createElement(React.Fragment, null,
                    React.createElement(UsecaseModelsStep, null),
                    React.createElement(MemorySettingsStep, null),
                    React.createElement(ToneSelectionStep, null),
                    isWhatsChanged && !isKPIAnalysis && (React.createElement(React.Fragment, null,
                        React.createElement("div", { style: { marginBottom: "10px", marginTop: "-10px" } },
                            React.createElement("div", { className: styles.wizardBoldText }, "Would you like to link to an Optimize Project?"),
                            React.createElement("div", { style: { width: "100%", padding: "0 1px 20px", marginTop: "8px" } },
                                React.createElement(Select, { options: linkedOptimizeReportOptions, value: selectedLinkedOptimizeReport, onChange: (val) => {
                                        const retLinkedOptimizeReport = {
                                            reportId: val?.value,
                                            datasetId: val?.datasetId
                                        };
                                        updateTemplateWizard("linkedOptimizeReport", retLinkedOptimizeReport);
                                    }, menuPlacement: "top" }))),
                        React.createElement(StartViewStep, { blueprintId: blueprintId }))),
                    isKPIAnalysis && (React.createElement(React.Fragment, null,
                        React.createElement("div", null,
                            React.createElement("input", { type: "checkbox", id: "reasoning-checkbox", 
                                // className={styles.extraOptionsButton}
                                style: {
                                    margin: "4px 6px 0 0"
                                }, onClick: () => updateTemplateWizard("autoDeepDive", !tryTemplate?.wizard?.autoDeepDive), checked: tryTemplate?.wizard?.autoDeepDive }),
                            React.createElement("label", { style: {
                                    marginBottom: "0px",
                                    fontSize: "14px"
                                }, htmlFor: "reasoning-checkbox" }, "Start Deep Dives Automatically")),
                        tryTemplate?.wizard?.autoDeepDive ? (React.createElement(React.Fragment, null,
                            React.createElement("div", { style: { marginTop: "6px", marginBottom: "10px" } },
                                React.createElement(SettingsKPISelection, { value: tryTemplate?.wizard?.autoDeepDiveColumns || [], options: KPIColumns, onChange: (val) => {
                                        const filteredColumns = KPIColumns.filter((o) => {
                                            return val?.includes(o);
                                        });
                                        updateTemplateWizard("autoDeepDiveColumns", val ? filteredColumns : undefined);
                                        if (!val?.length) {
                                            setCurrentLabelColumn("");
                                        }
                                        else if (!currentLabelColumn && val?.[0]) {
                                            setCurrentLabelColumn(val[0]);
                                        }
                                        else if (!val.includes(currentLabelColumn)) {
                                            setCurrentLabelColumn(val[0]);
                                        }
                                    }, placeholder: "Select Automatic Deep Dive Columns", menuPlacement: "top" })),
                            React.createElement("div", { className: styles.extraOptionsInputContainer },
                                React.createElement("div", { style: { display: "flex", alignItems: "center", marginBottom: "8px" } },
                                    React.createElement("div", { className: styles.wizardBoldText }, "Use custom labels in the Deep Dive Analyses?"),
                                    React.createElement(LabeledToggle, { style: { display: "block", marginLeft: "10px" }, checked: tryTemplate?.wizard?.autoDeepDiveUseCustomLabels, onChange: () => {
                                            updateTemplateWizard("autoDeepDiveUseCustomLabels", !tryTemplate?.wizard?.autoDeepDiveUseCustomLabels);
                                        }, isAibleColors: true })),
                                tryTemplate?.wizard?.autoDeepDiveUseCustomLabels ? (tryTemplate?.wizard?.autoDeepDiveColumns?.length > 0 ? (React.createElement(React.Fragment, null,
                                    React.createElement(ButtonGroup, { style: { marginBottom: "10px" } }, (tryTemplate?.wizard?.autoDeepDiveColumns || []).map((c) => {
                                        return (React.createElement(Button, { active: c === currentLabelColumn, onClick: () => {
                                                setCurrentLabelColumn(c);
                                            } }, c));
                                    })),
                                    React.createElement("div", { className: styles.extraOptionsMetricsLabels },
                                        React.createElement(KPIMetricsLabels, { hideChangeInBehavior: tryTemplate?.wizard?.autoDeepDiveCustomLabels?.[currentLabelColumn]
                                                ?.hideChangeInBehavior, hideChangeInPopulation: tryTemplate?.wizard?.autoDeepDiveCustomLabels?.[currentLabelColumn]
                                                ?.hideChangeInPopulation, hideChangeInOutcome: tryTemplate?.wizard?.autoDeepDiveCustomLabels?.[currentLabelColumn]
                                                ?.hideChangeInOutcome, hideChangeInTotalPopulation: tryTemplate?.wizard?.autoDeepDiveCustomLabels?.[currentLabelColumn]
                                                ?.hideChangeInTotalPopulation, renameBehavior: tryTemplate?.wizard?.autoDeepDiveCustomLabels?.[currentLabelColumn]
                                                ?.renameBehavior, renameOutcome: tryTemplate?.wizard?.autoDeepDiveCustomLabels?.[currentLabelColumn]?.renameOutcome, renamePopulation: tryTemplate?.wizard?.autoDeepDiveCustomLabels?.[currentLabelColumn]
                                                ?.renamePopulation, renameTotalPopulation: tryTemplate?.wizard?.autoDeepDiveCustomLabels?.[currentLabelColumn]
                                                ?.renameTotalPopulation, hideMissingInCharts: tryTemplate?.wizard?.autoDeepDiveCustomLabels?.[currentLabelColumn]
                                                ?.hideMissingInCharts, hideOtherInCharts: tryTemplate?.wizard?.autoDeepDiveCustomLabels?.[currentLabelColumn]
                                                ?.hideOtherInCharts, updateHideChangeInBehavior: (val) => handleUpdateTemplateDeepDiveLabel(currentLabelColumn, "hideChangeInBehavior", val), updateHideChangeInPopulation: (val) => handleUpdateTemplateDeepDiveLabel(currentLabelColumn, "hideChangeInPopulation", val), updateHideChangeInOutcome: (val) => handleUpdateTemplateDeepDiveLabel(currentLabelColumn, "hideChangeInOutcome", val), updateHideChangeInTotalPopulation: (val) => handleUpdateTemplateDeepDiveLabel(currentLabelColumn, "hideChangeInTotalPopulation", val), updateRenameBehavior: (val) => handleUpdateTemplateDeepDiveLabel(currentLabelColumn, "renameBehavior", val), updateRenameOutcome: (val) => handleUpdateTemplateDeepDiveLabel(currentLabelColumn, "renameOutcome", val), updateRenamePopulation: (val) => handleUpdateTemplateDeepDiveLabel(currentLabelColumn, "renamePopulation", val), updateRenameTotalPopulation: (val) => handleUpdateTemplateDeepDiveLabel(currentLabelColumn, "renameTotalPopulation", val), updateHideMissingInCharts: (val) => handleUpdateTemplateDeepDiveLabel(currentLabelColumn, "hideMissingInCharts", val), updateHideOtherInCharts: (val) => handleUpdateTemplateDeepDiveLabel(currentLabelColumn, "hideOtherInCharts", val) })))) : (React.createElement("div", { style: { color: "#868595", paddingBottom: "20px" } }, "Select deep dive columns to customize labels"))) : null))) : null)),
                    React.createElement(ExtraOptionsStep, { blueprintId: blueprintId, tryTemplate: tryTemplate, updateTemplateWizard: updateTemplateWizard }),
                    React.createElement("div", { style: { height: "20px" } }),
                    " ")))),
            React.createElement(DialogFooter, null,
                chatType === "OPTIMIZE" && (React.createElement(Button, { onClick: () => history.goBack(), isSmall: true }, "Back")),
                (!isEnabled("spark-agents-templates-view") ||
                    SPARK_TEMPLATES.map((template) => template.id).includes(blueprintId)) && (React.createElement(Button, { onClick: handleCreateAgent, isSmall: true, type: "primary", disabled: !isSetupReady ||
                        isInitializing ||
                        (datasetId === undefined && optimizeSetup !== undefined) ||
                        isSuggestDesc, isLoading: isCreatingAgent, loadingText: "Creating Agent" }, "Create Agent"))))));
};
const UsecaseModelsStep = () => {
    const dispatch = useDispatch();
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const isSql = chatType === "SQL";
    const secondaryModel = useSelector((state) => chatGPTReducer.getSecondaryModel(state));
    const secondaryModelOptions = useSelector((state) => chatGPTReducer.getSecondaryModelOptions(state, undefined, isEnabled("provisioned-models-filter-interns")));
    const updateSecondaryModel = (val) => dispatch(chatGPTReducer.updateSecondaryModel(val));
    const modelId = useSelector((state) => chatGPTReducer.getModelId(state));
    const modelOptions = useSelector((state) => chatGPTReducer.getModelOptions(state, undefined, undefined, isEnabled("provisioned-models-filter-interns")));
    const selectedModel = modelOptions.find((o) => o.value === modelId);
    const selectedSecondaryModel = secondaryModelOptions.find((o) => o.value === secondaryModel);
    const chatAppIsInitializing = useSelector((state) => chatGPTReducer.getChatAppIsInitializing(state));
    // Using first/2nd model in model options list as fallbacks if the chatTemplate's model strings don't exist as modelOptions
    const modelFallback = modelOptions?.[0]?.value;
    const secondaryModelFallback = secondaryModelOptions?.[1]?.value ?? secondaryModelOptions?.[0]?.value;
    useEffect(() => {
        if (!chatAppIsInitializing) {
            if (!selectedModel) {
                dispatch(chatGPTReducer.updateModelId(modelFallback));
            }
            if (!selectedSecondaryModel) {
                dispatch(chatGPTReducer.updateSecondaryModel(secondaryModelFallback));
            }
        }
    }, [chatAppIsInitializing]);
    return (React.createElement("div", { className: styles.wizardStepContent },
        React.createElement("div", { className: styles.wizardSettingWrapper },
            React.createElement("div", { className: styles.wizardBoldText }, "Confirm the AI Summarization Model"),
            React.createElement("div", { className: styles.wizardLightText }, "This model will understand context and summarize the answer"),
            React.createElement("div", { className: styles.wizardSelectorWrapper },
                React.createElement(ModelSelector, { onChange: selectOnChangeWrapper((val) => {
                        dispatch(chatGPTReducer.updateModelId(val));
                    }), hideIcons: true, style: { width: "100%", marginBottom: "10px" }, menuPlacement: "top" }),
                !selectedModel && React.createElement("div", { className: styles.wizardWarningText }, "Please select a model"))),
        isSql && (React.createElement("div", { className: styles.wizardSettingWrapper },
            React.createElement("div", { className: styles.wizardBoldText }, "Choose AI Model for SQL"),
            React.createElement("div", { className: styles.wizardSelectorWrapper },
                React.createElement(DynamicWidthSelector, { options: secondaryModelOptions, value: selectedSecondaryModel, onChange: selectOnChangeWrapper((val) => {
                        updateSecondaryModel(val);
                    }), menuPlacement: "top", isCreatable: true, style: { width: "100%", marginBottom: "10px" } }),
                !selectedSecondaryModel && React.createElement("div", { className: styles.wizardWarningText }, "Please select a model"))))));
};
const MemorySettingsStep = ({} = {}) => {
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const isNextSaving = useSelector((state) => nextReducer.getIsSavingReport(state, nextId));
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const disableButtons = isAsking || isNextSaving;
    if (!isEnabled("chat-conversation-memory")) {
        return null;
    }
    return (React.createElement("div", { className: "w-[100%] mb-[24px]" },
        React.createElement(MultiSessionMemoryCreationToggle, { disableButtons: disableButtons, skipLocalStorageUpdate: true }),
        React.createElement(MultiSessionMemoryToggle, { disableButtons: disableButtons, skipLocalStorageUpdate: true })));
};
const DataSelectionStep = ({ blueprintId, setIsKPIAnalysisReady, defaultDatasetId, defaultArtifactId, hideDatesOutsideRange, updateHideDatesOutsideRange }) => {
    const dispatch = useDispatch();
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const isDocSum = chatType === "DOCUMENT";
    const isNonDataChat = chatType === "CHAT" || chatType === "LLM";
    const isWhatsChanged = chatType === "WHATS_CHANGED";
    const isKpiAnalysis = chatType === "KPI_ANALYSIS";
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, "new"));
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const updateDatasetId = (val) => dispatch(nextReducer.updateDatasetId("new", val));
    const artifactId = useSelector((state) => chatGPTReducer.getArtifactId(state));
    const updateArtifactId = (val) => dispatch(chatGPTReducer.updateArtifactId(val));
    const blueprint = useSelector((state) => blueprintReducer.getBlueprint(state, blueprintId));
    const chatApps = useSelector((state) => viewReducer.getChatApps(state));
    const isUploadDocument = useSelector((state) => chatGPTReducer.getIsUploadDocument(state));
    const matchedSampleDataTemplate = blueprint?.wizard?.datasetId
        ? chatApps?.find((app) => app?.wizard?.isSampleData && app?.wizard?.datasetId === blueprint?.wizard?.datasetId)
        : undefined;
    const matchedSampleDocumentTemplate = blueprint?.wizard?.artifactId
        ? chatApps?.find((app) => app?.wizard?.isSampleData && app?.wizard?.artifactId === blueprint?.wizard?.artifactId)
        : undefined;
    const showSampleDatasetInfo = (chatType === "SQL" || chatType === "AIBLE" || chatType === "WHATS_CHANGED") &&
        datasetId &&
        datasetId !== "UPLOAD_CSV" &&
        datasetId !== "CHATAIBLE_DATA_SEARCH" &&
        datasetId === blueprint?.wizard?.datasetId &&
        TEMPLATES_SAMPLE_DATA[matchedSampleDataTemplate?.wizard?.templateSample] !== undefined;
    const showSampleDocumentInfo = chatType === "DOCUMENT" &&
        artifactId &&
        !isUploadDocument &&
        artifactId === blueprint?.wizard?.artifactId &&
        TEMPLATES_SAMPLE_DATA[matchedSampleDocumentTemplate?.wizard?.templateSample] !== undefined;
    const isKpiDriversTemplate = isKpiAnalysis || (isWhatsChanged && blueprint?.wizard?.templateType === "KPI_DRIVERS");
    if (isNonDataChat)
        return null;
    const artefactsWithDocumentsFilter = (artifact) => {
        return Boolean(artifact?.metadata?.document_list?.length);
    };
    if (isDocSum)
        return (React.createElement("div", { className: styles.wizardStepContent },
            React.createElement("div", { className: styles.wizardBoldText }, "What data would you like to use?"),
            React.createElement("div", null,
                React.createElement("div", { className: styles.wizardSelectorWrapper },
                    React.createElement(DocumentSelector, { artifactId: defaultArtifactId || artifactId, onChange: (val) => {
                            updateArtifactId(val?.id);
                        }, style: { width: "100%" }, selectorStyle: { width: "100%", marginBottom: "10px" }, allowUpload: true, forceSelection: true, menuPlacement: "bottom", sampleDataId: matchedSampleDocumentTemplate ? blueprint?.wizard?.artifactId : undefined, defaultAddData: true, filter: artefactsWithDocumentsFilter })),
                showSampleDocumentInfo && (React.createElement(SampleDataCard, { type: "DOCUMENT", data: TEMPLATES_SAMPLE_DATA[matchedSampleDocumentTemplate?.wizard?.templateSample] })))));
    return (React.createElement("div", { className: styles.wizardStepContent },
        React.createElement("div", { className: styles.wizardBoldText }, "What data would you like to use?"),
        React.createElement("div", null,
            React.createElement("div", { className: styles.wizardSelectorWrapper, style: { alignItems: "unset" } },
                React.createElement(DatasetSelector, { datasetId: defaultDatasetId || datasetId, onChange: (val) => {
                        if (val !== datasetId) {
                            dispatch(nextReducer.updateComparisonOptions("new", undefined));
                        }
                        updateDatasetId(val);
                    }, style: { width: "100%", marginBottom: "10px" }, menuPlacement: "bottom", forceDatasetSelection: true, hideJustChat: true, 
                    // hideDataSearch={true}
                    allowUpload: true, allowAllDatasets: true, skipSqlAutoSwitch: true, skipSearchRawChatSwitch: true, allowOutcomeSelect: chatType === "AIBLE" ||
                        chatType === "OPTIMIZE" ||
                        ((chatType === "WHATS_CHANGED" || chatType === "KPI_ANALYSIS") && !isKpiDriversTemplate), outcomeSelectStyle: { width: "100%", marginBottom: "8px" }, filter: chatType === "WHATS_CHANGED" || chatType === "KPI_ANALYSIS" ? "date" : undefined, sampleDatasetId: matchedSampleDataTemplate ? blueprint?.wizard?.datasetId : undefined, sampleDatasetLabel: matchedSampleDataTemplate
                        ? `${TEMPLATES_SAMPLE_DATA[matchedSampleDataTemplate?.wizard?.templateSample]?.name} (Sample Dataset)`
                        : undefined, hideDataSearch: isWhatsChanged || isKpiAnalysis, isChatTemplate: true, checkRawFieldsFilter: chatType === "WHATS_CHANGED", allowDatabaseLink: isEnabled("template-setup-database-link") })),
            showSampleDatasetInfo && (React.createElement(SampleDataCard, { type: "DATASET", data: TEMPLATES_SAMPLE_DATA[matchedSampleDataTemplate?.wizard?.templateSample] }))),
        (isWhatsChanged || isKpiAnalysis) && (React.createElement("div", { className: styles.whatsChangedWrapper },
            React.createElement(WhatsChangedInput, { fullWidthRangeStyle: true, isChatTemplate: true, isWhatsChangedOverview: isKpiDriversTemplate, isManualApply: false, defaultDatasetId: defaultDatasetId, defaultArtifactId: defaultArtifactId, hideDatesOutsideRange: hideDatesOutsideRange, updateHideDatesOutsideRange: updateHideDatesOutsideRange }),
            isKpiDriversTemplate && datasetId && dataset?.status_name === "DONE" && (React.createElement(KPIAnalysisSetup, { setIsKPIAnalysisReady: setIsKPIAnalysisReady }))))));
};
const SampleDataCard = ({ type, data }) => {
    return (React.createElement("div", { className: styles.sampleDataWrapper },
        React.createElement("div", { className: styles.sampleDataCard },
            React.createElement("div", { className: styles.sampleDataHeader },
                React.createElement("div", { className: styles.sampleDataTitleWrapper },
                    React.createElement("div", { className: styles.sampleDataIcon },
                        React.createElement("img", { src: type === "DATASET" ? CSVIconGray : documentSetIconGray })),
                    React.createElement("div", { className: styles.sampleDataLabel }, data?.name)),
                React.createElement("div", { className: styles.sampleLightText }, type === "DOCUMENT" ? "Sample Document" : "Sample Dataset")),
            React.createElement("div", { className: styles.sampleDescription }, data?.description),
            React.createElement("div", { className: styles.sampleDataDetails },
                data?.outcome !== undefined && data?.outcome?.length > 0 && (React.createElement(TileItem, { icon: "target", className: styles.sampleDataDetailItem }, data.outcome)),
                data?.rowCount && data?.rowCount > 0 && (React.createElement(TileItem, { icon: "rows", className: styles.sampleDataDetailItem },
                    React.createElement("span", null, (data?.rowCount > 1000 ? numeral(data?.rowCount).format("0.0a") : data?.rowCount) + " Rows, "),
                    (data?.columns && data?.columns > 1000 ? numeral(data?.columns).format("0.0a") : data?.columns) +
                        " Columns"))))));
};
const ToneSelectionStep = () => (React.createElement("div", { className: styles.wizardStepContent },
    React.createElement("div", { className: styles.wizardBoldText }, "Agent Response Format"),
    React.createElement("div", { className: styles.wizardSelectorWrapper },
        React.createElement(ToneSelector, { menuPlacement: "top", style: { width: "100%" } }))));
const StartViewStep = ({ blueprintId }) => {
    const dispatch = useDispatch();
    const appStartViewType = useSelector((state) => blueprintReducer.getAppStartViewType(state, blueprintId));
    const startInDashboard = useSelector((state) => chatAppReducer.getStartInDashboard(state));
    const appStartViewIsDashboard = appStartViewType === "DASHBOARD" || appStartViewType === undefined;
    // Syncing chatAppReducer startInDashboard for saving agents/initializing correct view.
    useEffect(() => {
        if (!startInDashboard) {
            dispatch(chatAppReducer.updateStartInDashboard(false));
            dispatch(blueprintReducer.updateAppStartViewType(blueprintId, "CHATGPT"));
        }
        else {
            dispatch(chatAppReducer.updateStartInDashboard(true));
            dispatch(blueprintReducer.updateAppStartViewType(blueprintId, "DASHBOARD"));
        }
    }, [blueprintId]);
    return (React.createElement("div", { className: styles.wizardStepContent, style: { marginBottom: "20px" } },
        React.createElement("div", { className: styles.extraOptionsButtonContainer },
            "Which view would you like to start in?",
            React.createElement(ButtonGroup, { style: { marginLeft: "10px" } },
                React.createElement(Button, { onClick: () => {
                        dispatch(blueprintReducer.updateAppStartViewType(blueprintId, "CHATGPT"));
                        dispatch(chatAppReducer.updateStartInDashboard(false));
                    }, active: appStartViewType === "CHATGPT" }, "Chat"),
                React.createElement(Button, { onClick: () => {
                        dispatch(blueprintReducer.updateAppStartViewType(blueprintId, "DASHBOARD"));
                        dispatch(chatAppReducer.updateStartInDashboard(true));
                    }, active: appStartViewIsDashboard }, "Dashboard")))));
};
const ExtraOptionsStep = ({ blueprintId, tryTemplate, updateTemplateWizard }) => {
    const dispatch = useDispatch();
    const chatType = useSelector((state) => chatGPTReducer.getChatType(state));
    const isAnalytics = chatType === "AIBLE" || chatType === "WHATS_CHANGED";
    const appInitSummarize = useSelector((state) => chatGPTReducer.getAppInitSummarize(state));
    const updateAppInitSummarize = (val) => dispatch(chatGPTReducer.updateAppInitSummarize(val));
    const replayPrompts = useSelector((state) => chatGPTReducer.getReplayPrompts(state));
    const appInitAutoAsk = useSelector((state) => chatGPTReducer.getAppInitAutoAsk(state));
    const updateAppInitAutoAsk = (val) => dispatch(chatGPTReducer.updateAppInitAutoAsk(val));
    // Hiding auto summary checkbox
    const isKPIAnalysis = useSelector((state) => chatAppReducer.getIsKPIAnalysis(state));
    const appStartViewType = useSelector((state) => blueprintReducer.getAppStartViewType(state, blueprintId));
    const startInDashboard = useSelector((state) => chatAppReducer.getStartInDashboard(state));
    //  Only show autosummary for analytics / deep dive with start on chat
    const showAutoSummary = chatType === "AIBLE" || (!isKPIAnalysis && isAnalytics && appStartViewType === "CHATGPT");
    const blueprint = useSelector((state) => blueprintReducer.getBlueprint(state, blueprintId));
    const templateType = blueprint?.wizard?.templateType;
    const isKpiDriversTemplate = templateType === "KPI_DRIVERS";
    const shouldStartAutoSummary = !isKpiDriversTemplate && (chatType === "WHATS_CHANGED" || chatType === "KPI_ANALYSIS");
    const reasoningEnabled = useSelector((state) => chatGPTReducer.getChatFlow(state)) === "REASONING";
    const optimizeSetup = useSelector((state) => chatGPTReducer.getOptimizeSetup(state));
    // Update to start KPI Deep Dive templates in chat with automatic summary on.
    useEffect(() => {
        if (!startInDashboard) {
            if (appInitSummarize && !shouldStartAutoSummary) {
                dispatch(chatGPTReducer.updateAppInitSummarize(false));
            }
            if (!appInitSummarize && shouldStartAutoSummary) {
                dispatch(chatGPTReducer.updateAppInitSummarize(true));
            }
        }
        else {
            dispatch(chatGPTReducer.updateAppInitSummarize(false));
        }
    }, [isKPIAnalysis, startInDashboard, appStartViewType]);
    return (React.createElement("div", { className: styles.wizardStepContent },
        React.createElement("div", { className: styles.extraOptionsButtonContainer },
            isAnalytics && showAutoSummary && (React.createElement("div", null,
                React.createElement("input", { type: "checkbox", id: "auto-summary-checkbox", 
                    // className={styles.extraOptionsButton}
                    style: {
                        margin: "4px 6px 0 0"
                    }, onClick: () => updateAppInitSummarize(!appInitSummarize), checked: appInitSummarize }),
                React.createElement("label", { style: {
                        marginBottom: "0px"
                    }, htmlFor: "auto-summary-checkbox" }, "Start Data Summarization Automatically"))),
            replayPrompts?.length > 0 && (React.createElement(Button, { className: styles.extraOptionsButton, onClick: () => updateAppInitAutoAsk(!appInitAutoAsk), active: appInitAutoAsk, greyscaleDefaultState: true }, appInitAutoAsk ? "Automatically Ask Saved Questions" : "No Automatic Questions"))),
        isEnabled("chat-reason") && !isKpiDriversTemplate && chatType !== "OPTIMIZE" && (React.createElement("div", { className: styles.extraOptionsButtonContainer },
            React.createElement("div", null,
                React.createElement("input", { type: "checkbox", id: "reasoning-checkbox", 
                    // className={styles.extraOptionsButton}
                    style: {
                        margin: "4px 6px 0 0"
                    }, onClick: () => {
                        const nextFlow = reasoningEnabled ? "DEFAULT" : "REASONING";
                        dispatch(chatGPTReducer.updateChatFlow(nextFlow));
                        updateTemplateWizard("chatFlow", nextFlow);
                    }, checked: reasoningEnabled }),
                React.createElement("label", { style: {
                        marginBottom: "0px"
                    }, htmlFor: "reasoning-checkbox" }, "Enable Reasoning Steps"))))));
};
export default withRouter(ChatTemplate);
